import axios from "axios";

let baseURL = "";
if (window.location.hostname === "localhost") {
  baseURL = process.env.REACT_APP_API_BASE_URL_LOCAL || "http://localhost:3050";
} else {
  baseURL = process.env.REACT_APP_API_BASE_URL_WEB || "http://localhost:3050";
}
export { baseURL };

// ============================================================================
// MAINTENANCE APIs - Modern async/await with axios instance
// ============================================================================

export const maintenanceApi = {
  getDevices: () => axios.get(baseURL + "/maintenance/getDevices"),

  getUsers: () =>
    axios.get(baseURL + "/maintenance/getoverallMaintenanceUsers"),

  getConfig: (deviceId) =>
    axios.get(baseURL + "/maintenance/getconfigMaintenance", {
      params: { DeviceID: deviceId },
    }),

  getSchedule: () => axios.get(baseURL + "/maintenance/getmaintenanceschedule"),

  getDashboards: () => axios.get(baseURL + "/maintenance/getDashboardList"),
  deleteDashboard: (dashboardId) =>
    axios.delete(baseURL + "/maintenance/deleteMaintenanceDashboard", {
      params: { deleteDashboard_dashboard_pro: dashboardId },
    }),

  createDashboard: (dashboardName, projectId) =>
    axios.post(baseURL + "/maintenance/postMaintenanceDashboardConfig", {
      dashboardName,
      projectid: projectId,
    }),

  saveDetails: (saveObject) =>
    axios.post(baseURL + "/maintenance/saveMaintenanceDetails", {
      saveobject: saveObject,
    }),

  getChecklist: (deviceId) =>
    axios.get(baseURL + "/maintenance/getCheckListMaintenance", {
      params: { DeviceID: deviceId },
    }),

  getDeviceParameters: (deviceId) =>
    axios.get(baseURL + "/maintenance/maintenancedeviceparameters", {
      params: { DeviceID: deviceId },
    }),

  saveUserForm: (saveObject) =>
    axios.post(baseURL + "/maintenance/saveUserForm", {
      saveobject: saveObject,
    }),
};

// ============================================================================
// OVERVIEW HOME APIs - Modern async/await with axios instance
// ============================================================================

export const overviewHomeApi = {
  getDashboards: () => axios.get(baseURL + "/overviewhome/getDashboardList"),

  deleteDashboard: (dashboardId, projectId, organizationId) =>
    axios.delete(baseURL + "/overviewhome/deleteStatusDashboard", {
      params: {
        deleteDashboard_dashboard_pro: dashboardId,
        projectid: projectId,
        organizationid: organizationId,
      },
    }),

  createDashboard: (payload) =>
    axios.post(baseURL + "/overviewhome/postOverviewHomeDashboard", payload),

  updateDashboard: (payload) =>
    axios.post(baseURL + "/overviewhome/postOverviewHomeDashboard", payload),
};

// ============================================================================
// STATUS TABLE APIs - Modern async/await with axios instance
// ============================================================================

export const statusTableApi = {
  getDashboards: () => axios.get(baseURL + "/statustable/getDashboardList"),

  deleteDashboard: (
    dashboardId,
    dashboardProjectId,
    dashboardOrganizationId,
    projectId,
    organizationId,
  ) =>
    axios.delete(baseURL + "/statustable/deleteStatusDashboard", {
      params: {
        deleteDashboard_dashboard_pro: dashboardId,
        DashboardProjectID: dashboardProjectId,
        DashboardOrganizationID: dashboardOrganizationId,
        projectid: projectId,
        organizationid: organizationId,
      },
    }),

  createDashboard: (payload) =>
    axios.post(baseURL + "/statustable/postStatusDashboard", payload),

  updateDashboard: (payload) =>
    axios.post(baseURL + "/statustable/postStatusDashboard", payload),
};

// Thermal Management API Service - Using backend proxy (no auth required for testing)
export const calculateThermalManagement = async (formData) => {
  try {
    const response = await axios.post(
      `${baseURL}/digital-twin/thermal-management/calculate`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
          // Note: Authentication removed for testing - endpoint is now public
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Thermal management calculation error:", error);
    throw error;
  }
};

var statusMessage = "";
var statusCode = "";

export const handleError = (status) => {
  let errorMessage = "";
  statusCode = status;

  switch (status) {
    case 200:
      errorMessage = "Success";
      break;
    case 204:
      errorMessage = "No Content Found for selected duration";
      break;
    case 400:
      errorMessage = "Bad Request: Please check your input parameters.";
      break;
    case 401:
      errorMessage = "Unauthorized: Please log in and try again.";
      break;
    case 403:
      errorMessage =
        "Forbidden: You do not have permission to access this resource.";
      break;
    case 404:
      errorMessage = "Not Found: The requested resource could not be found.";
      break;
    case 500:
      errorMessage =
        "Internal Server Error: Something went wrong on the server.";
      break;
    case 502:
      errorMessage = "Service Not Available";
      break;
    case 503:
      errorMessage = "Service Not Available";
      break;
    case 504:
      errorMessage = "Service Not Available";
      break;
    default:
      errorMessage = "no error";
      break;
  }
  statusMessage = errorMessage;
  return errorMessage;
};

export function loginverify(username, password, rememberMe, callback) {
  axios
    .post(baseURL + "/login", {
      user: username,
      password: password,
      rememberMe: rememberMe,
    })
    .then((res) => {
      callback(res);
      if (res.data?.data?.status) {
        axios.defaults.headers.common["Authorization"] =
          `Bearer ${res.data.data.Token}`;
        axios.defaults.headers.common["Index"] = 0;
      }
    })
    .catch((err) => {
      console.error("Login error:", err);
      callback({
        error: err.response
          ? err.response.data
          : { error: err.response?.message },
        status: err.response ? err.response.status : 500,
      });
    });
}

export function verifyOtp(otp, email, callback) {
  axios
    .post(baseURL + "/login/verify-otp", {
      email: email,
      otp: otp,
    })
    .then((res) => {
      callback(res);
      if (res.data.data.status) {
        axios.defaults.headers.common["Authorization"] =
          `Bearer ${res.data.data.Token}`;
      }
    })
    .catch((err) => {
      callback({ error: "Error logging in, please try again later" });
    });
}

export function resendOtp(email, callback) {
  console.log("resendOtp", email);
  axios
    .post(baseURL + "/login/resend-otp", {
      email: email,
    })
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      callback({ error: "Error logging in, please try again later" });
    });
}

export function changeselectedproject(index) {
  axios.defaults.headers.common["Index"] = index;
}

export function getProjectName(callback) {
  axios
    .get(baseURL + "/organization/getProjectName", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.error("Error in getProjectName:", err);
      callback({
        success: false,
        data: [],
        message: "Error fetching project names",
      });
    });
}

export function ciamloginverify(jwttoken, callback) {
  axios
    .post(baseURL + "/ciamlogin", null, {
      params: {
        token: jwttoken,
      },
    })
    .then((res) => {
     
      callback(res);
      if (res.data.data.status) {
        axios.defaults.headers.common["Authorization"] =
          `Bearer ${res.data.data.Token}`;
      }
    })
    .catch((err) => {
      callback({ error: "Error logging in, please try again later" });
    });
}

export function userLogout(username, projectId, organizationId) {
  return axios.post(
    baseURL + "/login/logout",
    { username, projectId, organizationId },
    {
      headers: { "Content-Type": "application/json" }, // ← Change this
    },
  );
}

export function getdashboarddetails(dashbaordname, orgid, projid, callback) {
  //console.log("getdashboarddetails ",dashbaordname)
  axios
    .get(baseURL + "/dashboard/dashboarddetails", {
      params: {
        dashboardname: dashbaordname,
        organizationid: orgid,
        projectid: projid,
      },
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.error("Dashboard details error:", err);
      let errorMessage;

      if (err.code === "ERR_CANCELED") {
        errorMessage = "Request was cancelled. Please try again.";
      } else if (err.code === "ECONNABORTED" || err.code === "ERR_TIMEOUT") {
        errorMessage =
          "Request timed out. The server is taking too long to respond.";
      } else if (
        err.code === "ERR_NETWORK" ||
        err.message === "Network Error"
      ) {
        errorMessage =
          "Unable to connect to the server. Please check if the server is running.";
      } else if (err.response) {
        errorMessage =
          err.response.data?.message || `Server error: ${err.response.status}`;
      } else if (err.request) {
        errorMessage =
          "No response from server. Please check if the server is running.";
      } else {
        errorMessage = err.message || "Error fetching dashboard details.";
      }

      callback({
        status: "failure",
        error: errorMessage,
        data: null,
      });
    });
}

export function getdashboarddata(
  taglistprops,
  startdate,
  enddate,
  flag,
  datetype,
  dashbaordname,
  Organizationid,
  Projectid,
  callback,
) {
  //console.log("getdashboarddata-params",params)
  const params = {
    taglistprops: taglistprops,
    startdate: startdate,
    enddate: enddate,
    flag: flag,
    datetype: datetype,
    dashboardname: dashbaordname,
    Organizationid: Organizationid,
    Projectid: Projectid,
  };


  axios
    .post(baseURL + "/dashboard/dashboarddata", params)
    .then((res) => {
      let msg = handleError(res.status);
      console.log("msg after getting response in then", msg);
      callback(res.data);
    })
    .catch((error) => {
      if (error.response) {
        let msg = handleError(error.response.status);
       }
    });

  /*axios.get(baseURL+'/dashboard/dashboarddata', {
        params: {
            taglistprops: taglistprops,
            startdate: startdate,
            enddate: enddate,
            datetype: datetype,
            dashboardname: dashbaordname    
        }
    })
    .then((res) => {
        callback(res.data)
    })*/
}

/**
 * Fetch dashboard data points (bulk query) from backend
 * @param {string} sdate - Start date (ISO string)
 * @param {string} edate - End date (ISO string)
 * @param {Array<{tagid: string, operation: string}>} tagidsArr - Array of tagid/operation objects
 * @param {string} datetype - Data type (e.g. 'Today')
 * @param {function} callback - Callback to handle response
 */
export function getDashboardDataPoints(
  sdate,
  edate,
  tagidsArr,
  datetype,
  callback,
) {
  const params = {
    sdate,
    edate,
    tagids: JSON.stringify(tagidsArr),
    datetype,
  };

  axios
    .get(baseURL + "/dashboard/dashboardDataPoints", { params })
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      callback({ status: "error", message: err.message });
    });
}

export function getdashboardhistoricaldata(
  taglistprops,
  startdate,
  enddate,
  flag,
  datetype,
  dashbaordname,
  callback,
) {

  // function dateToEpoch(date) {
  //   return new Date(date).getTime() / 1000;
  // }

  // const epoch_sdate = dateToEpoch(Date.parse(startdate));
  // const epoch_edate = dateToEpoch(Date.parse(enddate));

  // console.log("startdate ", startdate, epoch_sdate);

  const params = {
    taglistprops: taglistprops,
    startdate: startdate,
    enddate: enddate,
    flag: flag,
    datetype: datetype,
    dashboardname: dashbaordname,
  };
 
  axios
    .post(baseURL + "/dashboard/gethistoricaldata", params)
    .then((res) => {
      let msg = handleError(res.status);
      callback(res.data);
    })
    .catch((error) => {
      if (error.response) {
        let msg = handleError(error.response.status);
       }
    });

  /*axios.get(baseURL+'/dashboard/dashboarddata', {
        params: {
            taglistprops: taglistprops,
            startdate: startdate,
            enddate: enddate,
            datetype: datetype,
            dashboardname: dashbaordname    
        }
    })
    .then((res) => {
        callback(res.data)
    })*/
}

export function gethistoricaldata(
  taglistprops,
  startdate,
  enddate,
  flag,
  datetype,
  dashbaordname,
  Organizationid,
  Projectid,
  callback,
) {
  //console.log("getdashboarddata-params",params)
  const params = {
    taglistprops: taglistprops,
    startdate: startdate,
    enddate: enddate,
    flag: flag,
    datetype: datetype,
    dashboardname: dashbaordname,
    Organizationid: Organizationid,
    Projectid: Projectid,
  };
  axios
    .post(baseURL + "/dashboard/gethistoricaldashboarddata", params, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      
       //let msg = handleError(res.status);
      //console.log("msg after getting response in then", msg);
      callback(res.data);
    })
    .catch((error) => {
      if (error.response) {
        let msg = handleError(error.response.status);
       }
    });

  /*axios.get(baseURL+'/dashboard/dashboarddata', {
        params: {
            taglistprops: taglistprops,
            startdate: startdate,
            enddate: enddate,
            datetype: datetype,
            dashboardname: dashbaordname    
        }
    })
    .then((res) => {
        callback(res.data)
    })*/
}

export function getpowerqualityconfiguration(callback, projectid) {
  axios
    .get(baseURL + "/powerquality/powerqualityconfiguration", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      callback({
        data: {
          status: "failure",
          voltageharmonicsdetails: [],
          currentharmonicdetails: [],
        },
      });
    });
}

export function fetchPowerQualityData(callback, projectid) {
  axios
    .get(baseURL + "/powerquality/fetchPowerQualityData", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getSCMaxLoadCurrentThreshold(callback) {
  axios
    .get(baseURL + "/powerquality/getSCMaxLoadCurrentThreshold", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
     });
}

export function getPQDashboardList(callback) {
  axios
    .get(baseURL + "/powerquality/getDashboardList")
    .then((res) => {
      // Validate response structure
      if (res.data && res.data.data) {
        callback(res.data.data);
      } else {
        callback({
          success: false,
          data: [],
          code: 500,
          message: "Invalid response structure",
        });
      }
    })
    .catch((err) => {
      console.error("Error in getPQDashboardList:", err);

      // Categorize errors
      if (err.response) {
        // Server responded with error status
        callback({
          success: false,
          data: [],
          code: err.response.status,
          message:
            err.response.data?.data?.message ||
            "Server error while fetching dashboards",
        });
      } else if (err.request) {
        // Request made but no response received
        callback({
          success: false,
          data: [],
          code: 503,
          message: "Network error: Unable to reach server",
        });
      } else {
        // Error in request setup
        callback({
          success: false,
          data: [],
          code: 500,
          message: "Error setting up request: " + err.message,
        });
      }
    });
}

export function ChangePasswordAPI(
  email,
  currentPassword,
  newPassword,
  tempToken,
  callback,
) {
  // If tempToken is actually the callback (for backward compatibility)
  if (typeof tempToken === "function") {
    callback = tempToken;
    tempToken = null;
  }

  const requestBody = {
    email: email,
    newPassword: newPassword,
  };

  // Only add currentPassword if provided (not for expired password reset)
  if (currentPassword) {
    requestBody.currentPassword = currentPassword;
  }

  // Add temp token if provided (for expired password reset)
  if (tempToken) {
    requestBody.tempToken = tempToken;
  }

  axios
    .post(baseURL + "/login/changePassword", requestBody)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      callback({
        error: true,
        success: false,
        message:
          err.response?.data?.message ||
          "Error changing password, please try again later",
      });
    });
}

export function getMaintenanceDashboardList(callback) {
  axios
    .get(baseURL + "/maintenance/getDashboardList")
    .then((res) => {
      console.log("res Maintenance getDashboardList", res);

      // Check if response structure is valid
      if (res.data && res.data.data) {
        callback({
          success: res.data.data.success || false,
          data: res.data.data.data || [],
          code: res.data.data.code || res.status,
          message:
            res.data.data.message ||
            (res.data.data.success
              ? "Dashboards retrieved successfully"
              : "No dashboards found"),
        });
      } else {
        // Unexpected response structure
        callback({
          success: false,
          data: [],
          code: res.status,
          message: "Unexpected response format",
        });
      }
    })
    .catch((err) => {
      console.error("Error fetching Maintenance Dashboards:", err);

      // Handle different error scenarios
      if (err.response) {
        // Server responded with error status
        const status = err.response.status;
        const errorMessage = handleError(status);

        callback({
          success: false,
          data: [],
          code: status,
          message: err.response.data?.message || errorMessage,
        });
      } else if (err.request) {
        // Request made but no response received
        callback({
          success: false,
          data: [],
          code: 0,
          message: "Network error: Unable to reach server",
        });
      } else {
        // Error in request setup
        callback({
          success: false,
          data: [],
          code: 0,
          message: "Request error: " + err.message,
        });
      }
    });
}

export function postpowerqualityconfiguration(
  objecttosave,
  projectid,
  callback,
) {
  axios
    .post(
      baseURL + "/powerquality/postpowerqualityconfigurationdata",
      {
        objecttosave: JSON.stringify(objecttosave),
        projectid: projectid,
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    )
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      callback({
        data: { status: "failure", success: false, error: error?.message },
      });
    });
}

export function postPQDashboard(
  dashboardConfig,
  projectid,
  organizationid,
  callback,
) {
  console.log("dashboardConfig-postPQDashboard", dashboardConfig);
  axios
    .post(
      baseURL + "/powerquality/postdashboardConfig",
      {
        dashboardConfig: dashboardConfig,
        projectid: projectid,
        organizationid: organizationid,
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    )
    .then((res) => {
      console.log("res postpowerqualityconfiguration post POwer quality", res);
      callback(res.data);
    })
    .catch((error) => {
      callback({
        data: {
          success: false,
          status: "failure",
          data: [],
          error: error?.message,
        },
      });
    });
}

export function updatePQDashboard(
  Dashboardname,
  dashboardID,
  dashboardConfig,
  projectid,
  organizationid,
  callback,
) {
  console.log(
    "dashboardConfig-updatePQDashboard",
    dashboardConfig,
    "dashboardID",
    dashboardID,
  );
  axios
    .put(
      baseURL + "/powerquality/updateDashboardConfig",
      {
        Dashboardname: Dashboardname,
        dashboardID: dashboardID,
        dashboardConfig: dashboardConfig,
        projectid: projectid,
        organizationid: organizationid,
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    )
    .then((res) => {
      console.log(
        "res updatepowerqualityconfiguration post POwer quality",
        res,
      );
      callback(res.data);
    })
    .catch((error) => {
      callback({ data: { success: false, data: [], error: error?.message } });
    });
}

export function postMaintenanceDashboard(
  dashboardName,
  projectid,
  organizationid,
  callback,
) {
  axios
    .post(
      baseURL + "/maintenance/postMaintenanceDashboardConfig",
      {
        dashboardName: dashboardName,
        projectid: projectid,
        organizationid: organizationid,
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    )
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      callback({
        data: { status: "failure", success: false, error: error?.message },
      });
    });
}

export function deletepowerqualityconfiguration(
  objecttodelete,
  projectid,
  callback,
) {
  axios
    .delete(baseURL + "/powerquality/deletepowerqualityconfiguration", {
      params: {
        objecttodelete: objecttodelete,
        projectid: projectid,
      },
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.error("Error in deletepowerqualityconfiguration:", err);

      if (err.response) {
        // Server responded with error status
        callback({
          success: false,
          code: err.response.status,
          message:
            err.response.data?.message ||
            "Server error while deleting configuration",
        });
      } else if (err.request) {
        // Request made but no response received
        callback({
          success: false,
          code: 503,
          message: "Network error: Unable to reach server",
        });
      } else {
        // Error in request setup
        callback({
          success: false,
          code: 500,
          message: "Error setting up delete request: " + err.message,
        });
      }
    });
}

export function deletePQDashboard(
  deleteDashboard_dashboard_pro,
  projectid,
  organizationid,
  callback,
) {

  axios
    .delete(baseURL + "/powerquality/deletePQDashboard", {
      params: {
        deleteDashboard_dashboard_pro: deleteDashboard_dashboard_pro,
        projectid: projectid,
        organizationid: organizationid,
      },
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      console.error("error in deletePQDashboard", error);
      callback({ data: { success: false, data: [], error: error?.message } });
    });
}

export function deleteMaintenanceDashboard(
  deleteDashboard_dashboard_pro,
  projectid,
  organizationid,
  callback,
) {
  axios
    .delete(baseURL + "/maintenance/deleteMaintenanceDashboard", {
      params: {
        deleteDashboard_dashboard_pro: deleteDashboard_dashboard_pro,
      },
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      console.error("error in deleteMaintenanceDashboard", error);
      callback({ data: { success: false, data: [], error: error?.message } });
    });
}

export function deletecurrentpowerqualityconfiguration(
  objecttodelete,
  projectid,
  callback,
) {
  axios
    .delete(baseURL + "/powerquality/deletecurrentpowerqualityconfiguration", {
      params: {
        objecttodelete: objecttodelete,
      },
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response) {
        // Server responded with error status
        callback({
          success: false,
          code: err.response.status,
          message:
            err.response.data?.message ||
            "Server error occurred while deleting configuration",
        });
      } else if (err.request) {
        // Request made but no response received
        callback({
          success: false,
          code: 503,
          message: "Network error: Unable to reach server",
        });
      } else {
        // Error in request setup
        callback({
          success: false,
          code: 500,
          message: "Error setting up delete request: " + err.message,
        });
      }
    });
}

// export function getmaintenancetreedata(projectid,callback) {
//   axios
//     .get(baseURL + "/maintenance/maintenancetreedata", {
//       params: {

//       },
//     })
//     .then((res) => {
//       console.log("res reports maintenance",res)
//       callback(res.data);
//     });
// }

export function getdevicemaintenanceparameter(DeviceID, callback) {
  axios
    .get(baseURL + "/maintenance/maintenancedeviceparameters", {
      params: {
        DeviceID: DeviceID,
      },
    })
    .then((res) => {
      console.error("getdevicemaintenanceparameter-res", res);
      callback(res.data);
    })
    .catch((error) => {
      callback({
        data: { status: "failure", deviceparameters: [] },
        message: "Configuraton Data",
      });
    });
}

export function getmaintenanceschedule(Userid, callback) {
  console.error("Userid available", Userid);
  axios
    .get(baseURL + "/maintenance/getmaintenanceschedule", {
      params: {},
    })
    .then((res) => {
      console.error("getmaintenanceschedule-res", res);

      // Check if response structure is valid
      if (res.data && res.data.data) {
        callback({
          success: res.data.data.success || false,
          DeviceIDObject: res.data.data.DeviceIDObject || {},
          code: res.data.data.code || res.status,
          message:
            res.data.data.message ||
            (res.data.data.success
              ? "Schedules retrieved successfully"
              : "No schedules found"),
        });
      } else {
        // Unexpected response structure
        callback({
          success: false,
          DeviceIDObject: {},
          code: res.status,
          message: "Unexpected response format",
        });
      }
    })
    .catch((err) => {
      console.error("Error fetching maintenance schedule:", err);

      // Handle different error scenarios
      if (err.response) {
        // Server responded with error status
        const status = err.response.status;
        const errorMessage = handleError(status);

        callback({
          success: false,
          DeviceIDObject: {},
          code: status,
          message: err.response.data?.message || errorMessage,
        });
      } else if (err.request) {
        // Request made but no response received
        callback({
          success: false,
          DeviceIDObject: {},
          code: 0,
          message: "Network error: Unable to reach server",
        });
      } else {
        // Error in request setup
        callback({
          success: false,
          DeviceIDObject: {},
          code: 0,
          message: "Request error: " + err.message,
        });
      }
    });
}

export function getOverallMaintenanceUsers(callback) {
  axios
    .get(baseURL + "/maintenance/getoverallMaintenanceUsers")
    .then((res) => {
      console.error("getOverallMaintenanceUsers-res", res);

      // Check if response structure is valid
      if (res.data && res.data.data) {
        callback({
          success: res.data.data.success || false,
          UserDetails: res.data.data.UserDetails || [],
          code: res.data.data.code || res.status,
          message:
            res.data.data.message ||
            (res.data.data.success
              ? "Users retrieved successfully"
              : "No users found"),
        });
      } else {
        // Unexpected response structure
        callback({
          success: false,
          UserDetails: [],
          code: res.status,
          message: "Unexpected response format",
        });
      }
    })
    .catch((err) => {
      console.error("Error fetching maintenance users:", err);

      // Handle different error scenarios
      if (err.response) {
        // Server responded with error status
        const status = err.response.status;
        const errorMessage = handleError(status);

        callback({
          success: false,
          UserDetails: [],
          code: status,
          message: err.response.data?.data?.message || errorMessage,
        });
      } else if (err.request) {
        // Request made but no response received
        callback({
          success: false,
          UserDetails: [],
          code: 0,
          message: "Network error: Unable to reach server",
        });
      } else {
        // Error in request setup
        callback({
          success: false,
          UserDetails: [],
          code: 0,
          message: "Request error: " + err.message,
        });
      }
    });
}

export function getconfigMaintenance(DeviceID, callback) {
  axios
    .get(baseURL + "/maintenance/getconfigMaintenance", {
      params: {
        DeviceID: DeviceID,
      },
    })
    .then((res) => {
      console.error("getconfigMaintenance-res", res);
      callback(res.data);
    })
    .catch((error) => {
      console.error("Error fetching config maintenance:", error);
      callback({
        data: { status: "failure", configMaintenance: [] },
        message: "Configuraton Data",
      });
    });
}

export function getCheckListMaintenance(DeviceID, callback) {
  axios
    .get(baseURL + "/maintenance/getCheckListMaintenance", {
      params: {
        DeviceID: DeviceID,
      },
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response) {
        // Server responded with error status
        callback({
          success: false,
          data: { checkListMaintenance: [] },
          code: err.response.status,
          message:
            err.response.data?.message ||
            "Server error occurred while retrieving checklist",
        });
      } else if (err.request) {
        // Request made but no response received
        callback({
          success: false,
          data: { checkListMaintenance: [] },
          code: 503,
          message: "Network error: Unable to reach server",
        });
      } else {
        // Error in request setup
        callback({
          success: false,
          data: { checkListMaintenance: [] },
          code: 500,
          message: "Error setting up request: " + err.message,
        });
      }
    });
}

export function saveMaintenanceDetails(saveobject, callback) {
  axios
    .post(
      baseURL + "/maintenance/saveMaintenanceDetails",
      { saveobject: saveobject },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    )
    .then((res) => {
      console.error("res reports post POwer quality", res);
      callback(res.data);
    })
    .catch((error) => {
      console.error("Error saving maintenance details:", error);
      callback({
        data: {
          status: "failure",
          data: {
            savedconfigsuccess: false,
            savedparameterssuccess: false,
            savedchecklistsuccess: false,
          },
        },
        message: "Configuraton Data",
      });
    });
}

export function getDashboardPermissions(SubdashboardsIDArray, callback) {
  axios
    .get(baseURL + "/login/getDashboardPermissions", {
      params: {
        SubdashboardsIDArray: SubdashboardsIDArray,
      },
    })
    .then((res) => {
      console.error("resulkt getDashboardPermissions OPERATE DATABASE", res);
      callback(res.data, res.status);
    })
    .catch((error) => {
      console.error("error in getDashboardPermissions", error);
      callback([], "error");
    });
}

export function saveUserForm(saveobject, callback) {
  axios
    .post(
      baseURL + "/maintenance/saveUserForm",
      { saveobject: saveobject },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    )
    .then((res) => {
      console.error("res saveUserForm post Power quality", res);
      callback(res.data);
    })
    .catch((err) => {
      if (err.response) {
        // Server responded with error status
        callback({
          success: false,
          code: err.response.status,
          message:
            err.response.data?.message ||
            "Server error occurred while saving user form",
        });
      } else if (err.request) {
        // Request made but no response received
        callback({
          success: false,
          code: 503,
          message: "Network error: Unable to reach server",
        });
      } else {
        // Error in request setup
        callback({
          success: false,
          code: 500,
          message: "Error setting up request: " + err.message,
        });
      }
    });
}

export function getorganizationtree(callback) {
  axios
    .get(baseURL + "/organization/getorganizationtree", {
      headers: {
        "Content-Type": "application/json",
        /*"Access-Control-Allow-Origin":
          "https://backend-node-server-cffqhcbvhwangugw.centralindia-01.azurewebsites.net",
        "Access-Control-Allow-Methods": "OPTIONS,POST,GET,PUT,DELETE",*/
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function addorganization(orgjsondata, callback) {
  console.log("orgjson ", orgjsondata);
  axios
    .post(baseURL + "/organization/addorganization", orgjsondata, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

//DOUBT -- NOT USED ??
export function deleteorganization(organisationname, callback) {
  axios
    .delete(baseURL + "/organization/deleteorganization", {
      params: {
        orgname: organisationname,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function editorganization(orgjsondata, callback) {
  axios
    .put(baseURL + "/organization/editorganization", orgjsondata, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function addproject(projjsondata, callback) {
  console.log("projjson ", projjsondata);
  axios
    .post(baseURL + "/organization/addproject", projjsondata, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function editproject(projjsondata, callback) {
  axios
    .put(baseURL + "/organization/editproject", projjsondata, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function deleteproject(organisationname, projectname, callback) {
  axios
    .delete(baseURL + "/organization/deleteproject", {
      params: {
        orgname: organisationname,
        projectname: projectname,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getuserlistorganization(
  organizationname,
  projectname,
  callback,
) {
  axios
    .get(baseURL + "/user/userlist", {
      params: {
        orgname: organizationname,
        projname: projectname,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function adduser(userdata, callback) {
  console.log("userdata ", userdata);
  axios
    .post(baseURL + "/user/adduser", userdata, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function edituser(userdata, callback) {
  axios
    .put(baseURL + "/user/edituser", userdata, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function deleteuser(userdata, callback) {
  axios
    .delete(baseURL + "/user/deleteuser", {
      params: {
        userdetails: userdata,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

/*export function getgateways(callback) {
    axios.get(baseURL+'/gateway/getGateways',{ params: {
     }})
     .then((res) => {
        callback(res.data.gateways)
    })
}*/

/*export function gatewaycreate(gatewayinformation,callback) {
    axios.post(baseURL+'/gateway/createDevice',null,{ params: {
        gatewayinformation: gatewayinformation,
     }})
     .then((res) => {
        callback(res)
    })
}*/

/*export function setgatewaydata(gatewayinformation,id,callback) {
    axios.post(baseURL+'/gateway/setDeviceData',null,{ params: {
        gatewayinformation:gatewayinformation,
     }})
     .then((res) => {
        callback(res,id)
    })
}*/

/*export function getgatewaydata(id,callback) {
    axios.get(baseURL+'/gateway/getDeviceData',{ params: {
        id:id,
     }})
     .then((res) => {
        callback(res.data.gateway)
    })
}*/

/*export function gatewaydelete(id,gatewayno,callback) {
    axios.post(baseURL+'/gateway/deleteDevice',null,{ params: {
        id:id
     }})
     .then((res) => {
        callback(res,gatewayno)
    })
}*/

export function getdashboardgrouplist(orgid, projid, callback) {
  axios
    .get(baseURL + "/configuration/dashboardgrouplist", {
      params: {
        organizationid: orgid,
        projectid: projid,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function createdashboardgroup(orgid, projid, groupname, callback) {
  axios
    .post(baseURL + "/configuration/createdashboardgroup", null, {
      params: {
        organizationid: orgid,
        projectid: projid,
        groupname: groupname,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function postStatusDashboard(payload, callback) {
  axios
    .post(baseURL + "/statustable/postStatusDashboard", payload, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
    .then((res) => {
      console.log("res postpowerqualityconfiguration post POwer quality", res);
      callback(res.data);
    })
    .catch((error) => {
      console.log("error in postStatusDashboard", error);
      callback({
        data: {
          success: false,
          data: [],
          error: error?.message,
          message:
            error?.response?.data?.message ||
            "An error occurred while creating/updating status dashboard",
        },
      });
    });
}

export function deleteStatusDashboard(
  deleteDashboard_dashboard_pro,
  DashboardProjectID,
  DashboardOrganizationID,
  projectid,
  organizationid,
  callback,
) {
  console.log(
    "deleteDashboard_dashboard_pro-/statustable/deleteMaintenanceDashboard",
    deleteDashboard_dashboard_pro,
    "projectid",
    projectid,
    "organizationid",
    organizationid,
  );
  axios
    .delete(baseURL + "/statustable/deleteStatusDashboard", {
      params: {
        deleteDashboard_dashboard_pro: deleteDashboard_dashboard_pro,
        DashboardProjectID: DashboardProjectID,
        DashboardOrganizationID: DashboardOrganizationID,
        projectid: projectid,
        organizationid: organizationid,
      },
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      console.log("error in deletePQDashboard", error);
      callback({ data: { success: false, data: [], error: error?.message } });
    });
}

export function getStatusDashboardList(callback) {
  axios
    .get(baseURL + "/statustable/getDashboardList")
    .then((res) => {
      // Check if response structure is valid
      if (res.data && res.data.data) {
        callback({
          success: res.data.data.success || false,
          data: res.data.data.data || [],
          code: res.data.data.code || res.status,
          message:
            res.data.data.message ||
            (res.data.data.success
              ? "Dashboards retrieved successfully"
              : "No dashboards found"),
        });
      } else {
        // Unexpected response structure
        callback({
          success: false,
          data: [],
          code: res.status,
          message: "Unexpected response format",
        });
      }
    })
    .catch((err) => {
      console.error("Error fetching Status Dashboards:", err);

      // Handle different error scenarios
      if (err.response) {
        // Server responded with error status
        const status = err.response.status;
        const errorMessage = handleError(status);

        callback({
          success: false,
          data: [],
          code: status,
          message: err.response.data?.message || errorMessage,
        });
      } else if (err.request) {
        // Request made but no response received
        callback({
          success: false,
          data: [],
          code: 0,
          message: "Network error: Unable to reach server",
        });
      } else {
        // Error in request setup
        callback({
          success: false,
          data: [],
          code: 0,
          message: "Request error: " + err.message,
        });
      }
    });
}

// ============================================================================
// DEPRECATED: Legacy callback-based functions below
// Use overviewHomeApi object instead (lines 68-86)
// ============================================================================

// DEPRECATED: Use overviewHomeApi.getDashboards() instead
export function getOverviewDashboardList(callback) {
  console.warn(
    "DEPRECATED: getOverviewDashboardList() is deprecated. Use overviewHomeApi.getDashboards() with useApiHandler instead.",
  );
  axios
    .get(baseURL + "/overviewhome/getDashboardList")
    .then((res) => {
      console.log("res Overview getDashboardList", res);

      // Check if response structure is valid
      if (res.data && res.data.data) {
        callback({
          success: res.data.data.success || false,
          data: res.data.data.data || [],
          code: res.data.data.code || res.status,
          message:
            res.data.data.message ||
            (res.data.data.success
              ? "Dashboards retrieved successfully"
              : "No dashboards found"),
        });
      } else {
        // Unexpected response structure
        callback({
          success: false,
          data: [],
          code: res.status,
          message: "Unexpected response format",
        });
      }
    })
    .catch((err) => {
      console.error("Error fetching Overview Dashboards:", err);

      // Handle different error scenarios
      if (err.response) {
        // Server responded with error status
        const status = err.response.status;
        const errorMessage = handleError(status);

        callback({
          success: false,
          data: [],
          code: status,
          message: err.response.data?.message || errorMessage,
        });
      } else if (err.request) {
        // Request made but no response received
        callback({
          success: false,
          data: [],
          code: 0,
          message: "Network error: Unable to reach server",
        });
      } else {
        // Error in request setup
        callback({
          success: false,
          data: [],
          code: 0,
          message: "Request error: " + err.message,
        });
      }
    });
}

// DEPRECATED: Use overviewHomeApi.createDashboard() or overviewHomeApi.updateDashboard() instead
export function postOverviewHomeDashboard(payload, callback) {
  console.warn(
    "DEPRECATED: postOverviewHomeDashboard() is deprecated. Use overviewHomeApi.createDashboard() or overviewHomeApi.updateDashboard() with useApiHandler instead.",
  );
  axios
    .post(baseURL + "/overviewhome/postOverviewHomeDashboard", payload, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
    .then((res) => {
      console.log("res postpowerqualityconfiguration post POwer quality", res);
      callback(res.data);
    })
    .catch((error) => {
      callback({
        data: {
          success: false,
          data: [],
          error: error?.message,
          message:
            error?.response?.data?.message ||
            "An error occurred while creating/updating overview home dashboard",
        },
      });
    });
}

// DEPRECATED: Use overviewHomeApi.deleteDashboard() instead
export function deleteOverviewHome(
  deleteDashboard_dashboard_pro,
  projectid,
  organizationid,
  callback,
) {
  console.warn(
    "DEPRECATED: deleteOverviewHome() is deprecated. Use overviewHomeApi.deleteDashboard() with useApiHandler instead.",
  );
  console.log(
    "deleteDashboard_dashboard_pro-/overviewhome/deleteOverviewHome",
    deleteDashboard_dashboard_pro,
    "projectid",
    projectid,
    "organizationid",
    organizationid,
  );
  axios
    .delete(baseURL + "/overviewhome/deleteStatusDashboard", {
      params: {
        deleteDashboard_dashboard_pro: deleteDashboard_dashboard_pro,
        projectid: projectid,
        organizationid: organizationid,
      },
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      console.log("error in deletePQDashboard", error);
      callback({ data: { success: false, data: [], error: error?.message } });
    });
}

export function getdevicetagsModified(callback) {
  axios
    .get(baseURL + "/alarms/getTagDeviceStructure")
    .then((res) => {
      console.log("result getTagDeviceStructure", res.data);

      if (res.data && res.data.data) {
        callback({
          success: res.data.data.success || true,
          devices: res.data.data.devices || [],
          code: res.status,
          message:
            res.data.data.message ||
            "Device tag structure retrieved successfully",
        });
      } else {
        callback({
          success: false,
          devices: [],
          code: res.status,
          message: "Unexpected response format",
        });
      }
    })
    .catch((err) => {
      if (err.response) {
        // Server responded with error status
        let msg = handleError(err.response.status);
        console.error("Error in getdevicetags:", msg);
        callback({
          success: false,
          devices: [],
          code: err.response.status,
          message: err.response.data?.data?.message || msg,
        });
      } else if (err.request) {
        // Request was made but no response received
        console.error("No response received in getdevicetags:", err.request);
        callback({
          success: false,
          devices: [],
          code: 0,
          message:
            "No response from server. Please check your network connection.",
        });
      } else {
        // Something else caused the error
        console.error(
          "Error in setting up getdevicetags request:",
          err.message,
        );
        callback({
          success: false,
          devices: [],
          code: 0,
          message: err.message || "Failed to retrieve device tag structure",
        });
      }
    });
}

export function getdashboarlist(orgid, projid, groupid, callback) {
  axios
    .get(baseURL + "/configuration/dashboardlistforgroup", {
      params: {
        organizationid: orgid,
        projectid: projid,
        groupid: groupid,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function createdashboardname(
  orgid,
  projid,
  groupid,
  dashboardname,
  callback,
) {
  axios
    .post(baseURL + "/configuration/createdashboard", null, {
      params: {
        organizationid: orgid,
        projectid: projid,
        groupid: groupid,
        dashboardname: dashboardname,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function createplantview(orgid, projid, plantjson, callback) {
  console.log("plantjson ", plantjson);
  axios
    .post(
      baseURL + "/configuration/createplantview",
      {
        orgid: orgid,
        projid: projid,
        plantjson: JSON.stringify(plantjson),
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    )
    .then((res) => {
      callback(res.data);
    });
}

export function getplantview(orgid, projid, callback) {
  axios
    .get(baseURL + "/configuration/getplantviewjson", {
      params: {
        organizationid: orgid,
        projectid: projid,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function deletedahboard(dashboarddata, callback) {
  if (!dashboarddata) {
    callback &&
      callback({ status: "fail", message: "No dashboard data provided" });
    return;
  }
  const { key, dashboardname } =
    dashboarddata.key || dashboarddata.dashboardid
      ? {
          key: dashboarddata.key || dashboarddata.dashboardid,
          dashboardname: dashboarddata.dashboardname || dashboarddata.name,
        }
      : { key: undefined, dashboardname: undefined };

  axios
    .delete(baseURL + "/configuration/deletedashboard", {
      params: {
        dashboarddetails: {
          key,
          dashboardname,
        },
      },
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      callback && callback({ status: "fail", message: err.message });
    });
}

export function getdashboarddetailseditor(dashbaordid, callback) {
  //console.log("getdashboarddetails ",dashbaordname)
  axios
    .get(baseURL + "/configuration/dashboarddetailseditor", {
      params: {
        dashboardid: dashbaordid,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function updatedashboardwidgetlist(dashboardid, widgetlist, callback) {
  // Unified dashboard widget update with resilient fallback.
  // Preferred: PUT JSON body { dashboardid, widgetlist: [...] }
  // Legacy fallback: POST query params widgetlist (stringified) & dashboardid.
  if (!dashboardid) {
    return callback({ status: "fail", message: "dashboardid required" });
  }
  if (!widgetlist) {
    return callback({ status: "fail", message: "widgetlist required" });
  }
  const normalizedWidgetList =
    typeof widgetlist === "string"
      ? (() => {
          try {
            return JSON.parse(widgetlist);
          } catch {
            return widgetlist;
          }
        })()
      : widgetlist;

  // Ensure we always send an array; if single object wrap it.
  const widgetArray = Array.isArray(normalizedWidgetList)
    ? normalizedWidgetList
    : [normalizedWidgetList];
  const payload = { dashboardid, widgetlist: widgetArray };

  const putUrl = baseURL + "/configuration/updatedashboardwidgets";
  const postUrl = putUrl; // same endpoint for legacy fallback

  axios
    .put(putUrl, payload)
    .then((res) => {
      const data = res?.data || {};
      const statusToken = (data.status || res.status || "")
        .toString()
        .toLowerCase();
      callback && callback({ ...data, status: statusToken || "success" });
    })
    .catch((err) => {
      const statusCode = err?.response?.status;
      const shouldFallback =
        statusCode === 404 ||
        statusCode === 405 ||
        statusCode === 400 ||
        statusCode === 415 ||
        !statusCode;
      if (!shouldFallback) {
        callback &&
          callback({
            status: "fail",
            message: err?.message || "PUT update failed",
          });
        return;
      }
      // Legacy fallback POST with query params
      axios
        .post(postUrl, null, {
          params: {
            widgetlist: JSON.stringify(widgetArray),
            dashboardid,
          },
        })
        .then((res2) => {
          const data2 = res2?.data || {};
          const statusToken2 = (data2.status || res2.status || "")
            .toString()
            .toLowerCase();
          callback &&
            callback({
              ...data2,
              status: statusToken2 || "success",
              transport: "legacy-post",
            });
        })
        .catch((err2) => {
          callback &&
            callback({
              status: "fail",
              message:
                err2?.message || err?.message || "Widget list update failed",
            });
        });
    });
}

export function cloneDashboard(
  orgid,
  projid,
  sourceDashboardId,
  newGroupId,
  newName,
  callback,
) {
  axios
    .post(baseURL + "/configuration/cloneDashboard", {
      organizationid: orgid,
      projectid: projid,
      sourcedashboardid: sourceDashboardId,
      newgroupid: newGroupId,
      newname: newName,
    })
    .then((res) => callback && callback(res.data))
    .catch(
      (err) => callback && callback({ status: "fail", message: err.message }),
    );
}

export function getassets(callback) {
  axios
    .get(baseURL + "/asset/getAssetsList", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    });
}

//livedata
/*export function livedata(callback) {
    console.log(" in live data ")
    axios.get( 'https://operate-datacomm-server-dggfbpcub8hkbgh5.centralindia-01.azurewebsites.net/getlivedata', {
        
    })
    .then((res) => {
        console.log("res in live data ",res)
        callback(res)
    })
}*/

export function gatewaycreate(gatewayinformation, callback) {
  axios
    .post(baseURL + "/gateway/createDevice", {
      gatewayinformation: gatewayinformation,
    })
    .then((res) => {
      callback(res);
    });
}

export function gatewaydelete(deletegatewayno, callback) {
  axios
    .post(baseURL + "/gateway/deleteDevices", {
      deletegatewayno: deletegatewayno,
    })
    .then((res) => {
      callback(res);
    });
}

export function getgateways(callback) {
  axios
    .get(baseURL + "/gateway/getGateways", {
      params: {},
    })
    .then((res) => {
      callback(res.data.gateways);
    });
}

export function getGatewayConnectionAnalysis(callback) {
  axios
    .get(baseURL + "/gateway/getGatewayConnectionAnalysis")
    .then((res) => {
      callback(null, res.data);
    })
    .catch((err) => {
      callback(err, null);
    });
}

export function devicecreate(deviceinformation, ismeter, callback) {
  axios
    .post(baseURL + "/device/createDevice", {
      deviceinformation: deviceinformation,
      ismeter: ismeter,
    })
    .then((res) => {
      callback(res);
    });
}

export function devicedelete(deletedeviceno, callback) {
  axios
    .post(baseURL + "/device/deleteDevice", {
      deletedeviceno: deletedeviceno,
    })
    .then((res) => {
      callback(res);
    });
}

export function tagdelete(deviceId, deleteTags, callback) {
  axios
    .post(baseURL + "/device/deletetags", {
      deviceId: deviceId,
      deleteTags: deleteTags,
    })
    .then((res) => {
      callback(res);
    });
}

export function getdevices(callback) {
  axios
    .get(baseURL + "/device/getDevices", {
      params: {},
    })
    .then((res) => {
      callback(res.data.devices);
    });
}

export function getalltags(deviceId, callback) {
  axios
    .get(baseURL + "/device/getAllTags", {
      params: {
        deviceId: deviceId,
      },
    })
    .then((res) => {
      callback(res.data.tags);
    });
}

export function getdevicesMaintenance(callback) {
  console.log("getdevicesMaintenance");
  axios
    .get(baseURL + "/maintenance/getDevices")
    .then((res) => {
      console.log("getdevicesMaintenance-res", res);

      // Check if response structure is valid
      if (res.data && res.data.devices) {
        callback({
          success: true,
          devices: res.data.devices || [],
          code: res.status,
          message: res.data.message || "Devices retrieved successfully",
        });
      } else {
        // Unexpected response structure
        callback({
          success: false,
          devices: [],
          code: res.status,
          message: "Unexpected response format",
        });
      }
    })
    .catch((err) => {
      console.error("Error fetching maintenance devices:", err);

      // Handle different error scenarios
      if (err.response) {
        // Server responded with error status
        const status = err.response.status;
        const errorMessage = handleError(status);

        callback({
          success: false,
          devices: [],
          code: status,
          message: err.response.data?.message || errorMessage,
        });
      } else if (err.request) {
        // Request made but no response received
        callback({
          success: false,
          devices: [],
          code: 0,
          message: "Network error: Unable to reach server",
        });
      } else {
        // Error in request setup
        callback({
          success: false,
          devices: [],
          code: 0,
          message: "Request error: " + err.message,
        });
      }
    });
}

export function getgatewaylist(callback) {
  axios
    .get(baseURL + "/device/getgatewaylist", {
      params: {},
    })
    .then((res) => {
      callback(res.data.gateways);
    });
}

export function assetcreate(assetinformation, callback) {
  axios
    .post(baseURL + "/asset/createasset", {
      assetinformation: assetinformation,
    })
    .then((res) => {
      callback(res);
    });
}

export function assetdelete(deleteassetno, callback) {
  axios
    .post(baseURL + "/asset/deleteasset", {
      deleteassetno: deleteassetno,
    })
    .then((res) => {
      callback(res);
    });
}

export function getassets1(callback) {
  axios
    .get(baseURL + "/asset/getAssets", {
      params: {},
    })
    .then((res) => {
      callback(res.data.assets);
    });
}

export function getdevicelist(callback) {
  axios
    .get(baseURL + "/device/getdevicelist", {
      params: {},
    })
    .then((res) => {
      callback(res.data.devices);
    });
}

export function getDeviceTypes(callback) {
  axios
    .get(baseURL + "/device/getDeviceTypes", {
      params: {},
    })
    .then((res) => {
      callback(res.data.devicetypes);
    });
}

export function getTagUnitsandDataTypes(callback) {
  axios
    .get(baseURL + "/device/getTagUnitsandDataTypes", {
      params: {},
    })
    .then((res) => {
      callback(res);
    });
}

export function livedata(payloadOrCallback, callbackArg) {
  let payload = {};
  let callback = callbackArg;

  if (typeof payloadOrCallback === "function") {
    callback = payloadOrCallback;
  } else if (payloadOrCallback && typeof payloadOrCallback === "object") {
    payload = payloadOrCallback;
  }

  if (typeof callback !== "function") {
    return;
  }

  //console.log(" in live data ")
  //axios.get( 'https://operate-datacomm-server-dggfbpcub8hkbgh5.centralindia-01.azurewebsites.net/getlivedata', {
  /*axios.get( 'http://localhost:3050/getlivedata', {
        
    })
    .then((res) => {
        console.log("res in live data ",res)
        callback(res)
    })*/

  axios
    .post(baseURL + "/livedata", payload, {
      headers: {
        "Content-Type": "application/json",
        /*"Access-Control-Allow-Origin":
      "https://backend-node-server-cffqhcbvhwangugw.centralindia-01.azurewebsites.net",
    "Access-Control-Allow-Methods": "OPTIONS,POST,GET,PUT,DELETE",*/
      },
    })
    .then((res) => {
      //console.log("live",res)
      callback(res);
    }).catch((error) => {
      console.error("Error in livedata API call:", error);
      callback({ error: error.message || "Failed to fetch live data" });
    });
}



export function gatewaylivedata(deviceId, callback) {
  axios
    .get(baseURL + "/gateway/getstatus", {
      params: {
        deviceId: deviceId,
      },
    })
    .then((res) => {
      callback(res);
    });
}

export function allorggatewaylivedata(callback) {
  axios
    .get(baseURL + "/gateway/getOrgAllGatewayStatus", {
      params: {
        // deviceId: deviceId,
      },
    })
    .then((res) => {
      callback(res);
    });
}

export function deviceconnetionStatus(callback) {
  axios
    .get(baseURL + "/device/getstatus", {
      params: {},
    })
    .then((res) => {
      callback(res);
    });
}

export function setEAnalyticsData(analyticsConfiginfo, callback) {
  axios
    .post(baseURL + "/module/setEAnalyticsData", {
      analyticsConfiginfo: analyticsConfiginfo,
    })
    .then((res) => {
      callback(res);
    });
}

export function getEAnalyticsData(callback) {
  axios.get(baseURL + "/module/getEAnalyticsConfig", {}).then((res) => {
    callback(res);
  });
}

export function setEAccountingData(accountingConfiginfo, callback) {
  axios
    .post(baseURL + "/module/setEAccountingData", {
      accountingConfiginfo: accountingConfiginfo,
    })
    .then((res) => {
      callback(res);
    });
}

export function getEAccountingData(callback) {
  axios.get(baseURL + "/module/getEAccountingConfig", {}).then((res) => {
    callback(res);
  });
}

export function setGeneralConfiguration(generalConfigInfo, callback) {
  axios
    .post(baseURL + "/general/setGeneralConfiguration", {
      generalConfigInfo: generalConfigInfo,
    })
    .then((res) => {
      callback(res);
    });
}

export function getGeneralConfiguration(callback) {
  axios.post(baseURL + "/general/getGeneralConfiguration", null).then((res) => {
    callback(res);
  });
}

export function getGroupOptions(callback) {
  axios
    .get(baseURL + "/report/groupOptions", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getTagDetails(tagid, callback) {
  axios
    .get(baseURL + "/asset/getTagDetails", {
      params: {
        tagidparameter: tagid,
      },
    })
    .then((res) => {
      console.log("resulkt getTagDetails", res.data.data);
      callback(res.data.data);
    })
    .catch((error) => {
      if (error.response) {
        // console.log("in get config Alarms ",error.response)
        // let msg =handleError(error.response.status)
        // // console.log("msg after getting response in catch", msg);
      }
    });
}

export function getDeviceTagMapping(callback) {
  axios
    .get(baseURL + "/asset/deviceTagMapping", {
      param: {},
    })
    .then((res) => {
      //console.log("resulkt getDeviceTagMapping", res);
      callback(res);
    })
    .catch((error) => {
      if (error.response) {
        // console.log("in get config Alarms ",error.response)
        // let msg =handleError(error.response.status)
        // // console.log("msg after getting response in catch", msg);
      }
    });
}

export function getDeviceTagMappingToastMessage(callback) {
  axios
    .get(baseURL + "/asset/deviceTagMappingToastMessage", {
      param: {},
    })
    .then((res) => {
      //console.log("resulkt getDeviceTagMapping", res);
      callback(res);
    })
    .catch((error) => {
      if (error.response) {
        // console.log("in get config Alarms ",error.response)
        // let msg =handleError(error.response.status)
        // // console.log("msg after getting response in catch", msg);
      }
    });
}

export function getdevicetags(projectid, callback) {
  axios
    .get(baseURL + "/asset/getTagDeviceStructure", {
      params: {
        projectid: projectid,
      },
    })
    .then((res) => {
      console.log("resulkt getTagDeviceStructure", res.data);
      callback(res.data);
    })
    .catch((error) => {
      if (error.response) {
        let msg = handleError(error.response.status);
        console.log("Error in getgatewaydata:", msg);
      } else if (error.request) {
        // Request was made but no response received
        console.error("No response received:", error.request);
      } else {
        // Something else caused the error
        console.error("Error in setting up request:", error.message);
      }
    });
}

export function getdevicetagsnew(callback) {
  axios
    .get(baseURL + "/asset/getTagDeviceStructure", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getalarmeventsrecords(projectid, callback) {
  console.log("in getalarmeventsrecords projectid", projectid);
  axios
    .get(baseURL + "/alarms/getAlarmEvents", {
      params: {
        projectid: projectid,
      },
    })
    .then((res) => {
      console.log("/getAlarmEvents data----/////////", res);
      callback({ data: res.data, status: "success" });
    })
    .catch((error) => {
      if (error.response) {
        let msg = handleError(error.response.status);
        console.log("Error in getgatewaydata:", msg);
        callback({ data: [], status: "failure" });
      } else if (error.request) {
        callback({ data: [], status: "failure" });
        // Request was made but no response received
        console.error("No response received:", error.request);
      } else {
        callback({ data: [], status: "failure" });
        // Something else caused the error
        console.error("Error in setting up request:", error.message);
      }
    });
}

export function postalarmconfig(alarmconfig, userid, projectid, callback) {
  console.log("---alarmconfig received here in operate qsr", alarmconfig);
  axios
    .post(
      baseURL + "/alarms/postAlertsConfig",
      {
        alarmconfigparameter: alarmconfig,
        process: "ALERT_CREATION",
        timestamp: Date.now(),
        userid: userid,
        action: "CREATE",
        old_value: "",
        new_value: "",
        comment: "Alert rule is created",
        projectid: projectid,
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    )
    .then((res) => {
      console.log("res postalarmconfig restclieby", res);
      callback(res, res.status);
    })
    .catch((error) => {
      console.log("error postalarmconfig", error);
      callback(error.response, error.status);
    });
}

export function postsnoozeAlarmConfig(
  snoozeconfig,
  ProjectID,
  id,
  userid,
  projectid,
  callback,
) {
  console.log("---snoozeconfig received here in operate qsr", snoozeconfig);
  axios
    .post(
      baseURL + "/alarms/postsnoozeAlarmConfig",
      {
        snoozeconfig: snoozeconfig,
        ProjectID: ProjectID,
        id: id,
        process: "ALERT_SNOOZE",
        timestamp: Date.now(),
        userid: userid,
        action: "CREATE",
        old_value: "",
        new_value: "",
        comment: "Alert rule is created",
        projectid: projectid,
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    )
    .then((res) => {
      console.log("res postalarmconfig restclieby", res);
      callback(res, res.status);
    })
    .catch((error) => {
      callback(error.message, "error");
    });
}

// export function deleteAlarmConfig(callback,userid, projectid, alarm_rule) {
//   console.log("in datacollection deleteAlarmConfig alarm_rule", alarm_rule);

//   axios
//     .delete(baseURL + "/alarms/deleteAlarmConfig", {
//       params: {
//         alarm_rule_parameter: alarm_rule,
//         process:"ALERT_DELETE",
//         timestamp:Date.now(),
//         userid:userid,
//         action:"DELETE",
//         old_value:alarm_rule,
//         new_value:'',
//         comment:'Alert rule is deleted',
//         projectid:projectid
//       },
//     })
//     .then((res) => {
//       console.log("resulkt deleteAlarmConfig",res);
//       callback({ data: res.data.data, status: 'success' });

//     })
//     .catch((error) => {
//       let msg = "Unknown error";
//       if (error.response) {
//         let msg = handleError(error.response.status);
//         console.log("Error in getgatewaydata:", msg);
//       }
//       else if (error.request) {
//         msg = "No response received from server";
//         console.error(msg, error.request);
//       } else {
//         msg = error.message;
//         console.error("Error in setting up request:", msg);
//       }
//       callback({ data: {}, status: 'failure', error: msg });

//     });
// }

export function deleteAlarmConfig(callback, userid, projectid, alarm_rule) {
  console.log("in datacollection deleteAlarmConfig alarm_rule", alarm_rule);

  axios
    .delete(baseURL + "/alarms/deleteAlarmConfig", {
      params: {
        alarm_rule_parameter: alarm_rule,
        process: "ALERT_DELETE",
        timestamp: Date.now(),
        userid: userid,
        action: "DELETE",
        old_value: alarm_rule,
        new_value: "",
        comment: "Alert rule is deleted",
        projectid: projectid,
      },
    })
    .then((res) => {
      // Use backend response code and message
      const { success, message, code, error } = res.data;
      if (success) {
        callback({ data: res.data, status: "success", message, code });
      } else {
        callback({ data: res.data, status: "failure", message, code, error });
      }
    })
    .catch((error) => {
      console.log("error in deleteAlarmConfig", error);
      let msg = "Unknown error";
      let code = 500;
      if (error.response) {
        code = error.response.status;
        msg = error.response.data?.message || handleError(code);
        console.log("Error in deleteAlarmConfig:", msg);
      } else if (error.request) {
        msg = "No response received from server";
        console.error(msg, error.request);
      } else {
        msg = error.message;
        console.error("Error in setting up request:", msg);
      }
      callback({ data: {}, status: "failure", message: msg, code });
    });
}

export function postuniquealarmconfig(
  alarmconfig,
  userid,
  projectid,
  oldvalue,
  callback,
) {
  console.log(
    "---alarmconfig postuniquealarmconfig------------***************////////////////////",
    alarmconfig,
  );
  axios
    .put(
      baseURL + "/alarms/postUniqueAlarm",
      {
        alarmconfigparameter: alarmconfig,
        process: "ALERT_UPDATE",
        timestamp: Date.now(),
        userid: userid,
        action: "UPDATE",
        old_value: oldvalue,
        new_value: alarmconfig,
        comment: "Alert rule is updated",
        projectid: projectid,
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    )
    .then((res) => {
      const { success, message, code, error, itemobtainedmethod, item } =
        res.data;
      callback({ success, message, code, error, itemobtainedmethod, item });
    })
    .catch((error) => {
      let msg = "Unknown error";
      let code = 500;
      if (error.response) {
        code = error.response.status;
        msg = error.response.data?.message || handleError(code);
        console.log("Error in postuniquealarmconfig:", msg);
      } else if (error.request) {
        msg = "No response received from server";
        console.error(msg, error.request);
      } else {
        msg = error.message;
        console.error("Error in setting up request:", msg);
      }
      callback({ success: false, message: msg, code, error: error });
    });
}

export function getAlarmConfig(projectid, projectlist, callback) {
  console.log("in datacollection getAlarmConfig projectid", projectid);
  axios
    .get(baseURL + "/alarms/fetchAlarmConfig", {
      params: {
        projectid: projectid,
        projectlist: projectlist,
      },
    })
    .then((res) => {
      console.log("res-getAlarmConfig", res);
      callback(res, res.status);
    })
    .catch((error) => {
      console.log("error in getAlarmConfig", error);
      callback(error.message, "error");
    });
}

export function getGroupTree(projectid, callback) {
  axios
    .get(baseURL + "/alarms/getGroupTree", {
      params: {},
    })
    .then((res) => {
      callback(res, res.status);
    })
    .catch((error) => {
      callback(error.message, "error");
    });
}

export function postGroupTree(ProjectID, userid, groups, callback) {
  console.log(
    "in postGroupTree datacollection postGroupTree ProjectID, userid, groups",
    ProjectID,
    userid,
    groups,
  );

  axios
    .post(
      baseURL + "/alarms/postGroupTree",
      {
        groups: JSON.stringify(groups),
        process: "ALERT_CREATION",
        timestamp: Date.now(),
        userid: userid,
        action: "CREATE",
        old_value: "",
        new_value: "",
        comment: "Alert rule is created",
        ProjectID: ProjectID,
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    )
    .then((res) => {
      console.log("res postalarmconfig restclieby", res);
      callback(res, res.status);
    })
    .catch((error) => {
      callback(error.message, "error");
    });
}

export function deleteGroupTree(ProjectID, userid, callback) {
  console.log(
    "in deleteGroupTree datacollection deleteGroupTree ProjectID, userid",
    ProjectID,
    userid,
  );

  axios
    .delete(baseURL + "/alarms/deleteGroupTree", {
      params: {
        ProjectID: ProjectID,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
    .then((res) => {
      callback(res, res.status);
    })
    .catch((error) => {
      callback(error.message, "error");
    });
}

export function addcommentalarmeventrecord(
  comment,
  alarmeventrecord,
  callback,
) {
  // console.log("addcommentalarmeventrecord(alarmeventrecord)/////////////in datacollection",alarmeventrecord)
  axios
    .put(
      baseURL + "/alarms/addcommentAlarmEventRecord",
      { comment: comment, alarmeventrecord: alarmeventrecord },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    )
    .then((res) => {
      console.log("res-addcommentalarmeventrecord", res);
      callback(res.data);
    })
    .catch((error) => {
      if (error.response) {
        let msg = handleError(error.response.status);
        console.log("Error in getgatewaydata:", msg);
      } else if (error.request) {
        // Request was made but no response received
        console.error("No response received:", error.request);
      } else {
        // Something else caused the error
        console.error("Error in setting up request:", error.message);
      }
    });
}

export function getTagDetailsInformationProjectwise(
  projectid,
  projectlist,
  callback,
) {
  axios
    .get(baseURL + "/alarms/getTagDetailsInformationProjectwise", {
      params: {},
      headers: {
        "Content-Type": "application/json",
        /*"Access-Control-Allow-Origin":
        "https://backend-node-server-cffqhcbvhwangugw.centralindia-01.azurewebsites.net",
      "Access-Control-Allow-Methods": "OPTIONS,POST,GET,PUT,DELETE",*/
      },
    })
    .then((res) => {
      console.log("projectid-getTagDetailsInformationProjectwise", res);
      callback(res.data);
    })
    .catch((error) => {
      if (error.response) {
        let msg = handleError(error.response.status);
        console.log("Error in getgatewaydata:", msg);
        callback({ data: { taginformationkey: {} } });
      } else if (error.request) {
        // Request was made but no response received
        console.error("No response received:", error.request);
        callback({ data: { taginformationkey: {} } });
      } else {
        // Something else caused the error
        console.error("Error in setting up request:", error.message);
        callback({ data: { taginformationkey: {} } });
      }
    });
}

export function getDeviceDetailsInformationProjectwise(
  projectid,
  projectlist,
  callback,
) {
  axios
    .get(baseURL + "/alarms/getDeviceDetailsInformationProjectwise", {
      params: {},
      headers: {
        "Content-Type": "application/json",
        /*"Access-Control-Allow-Origin":
        "https://backend-node-server-cffqhcbvhwangugw.centralindia-01.azurewebsites.net",
      "Access-Control-Allow-Methods": "OPTIONS,POST,GET,PUT,DELETE",*/
      },
    })
    .then((res) => {
      console.log("projectid-getDeviceDetailsInformationProjectwise", res);
      callback(res.data);
    })
    .catch((error) => {
      if (error.response) {
        let msg = handleError(error.response.status);
        console.log("Error in getgatewaydata:", msg);
        callback({ data: { deviceinformationkey: {} } });
      } else if (error.request) {
        // Request was made but no response received
        console.error("No response received:", error.request);
        callback({ data: { deviceinformationkey: {} } });
      } else {
        // Something else caused the error
        console.error("Error in setting up request:", error.message);
        callback({ data: { deviceinformationkey: {} } });
      }
    });
}

export function acknowledgealarmeventrecord(alarmeventrecord, callback) {
  console.log(
    "acknowledgealarmeventrecord(alarmeventrecord) in datacollection",
    alarmeventrecord,
  );
  axios
    .put(
      baseURL + "/alarms/acknowledgeAlarmEventRecord",
      { alarmeventrecord: alarmeventrecord },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    )
    .then((res) => {
      console.log("res-acknowledgealarmeventrecord", res);
      callback(res.data);
    })
    .catch((error) => {
      if (error.response) {
        let msg = handleError(error.response.status);
        console.log("Error in getgatewaydata:", msg);
      } else if (error.request) {
        // Request was made but no response received
        console.error("No response received:", error.request);
      } else {
        // Something else caused the error
        console.error("Error in setting up request:", error.message);
      }
    });
}

export function getHistoricalAlarms(projectid, startdate, enddate, callback) {
  console.log(
    "getHistoricalAlarms projectid, startdate, enddate",
    projectid,
    startdate,
    enddate,
  );
  axios
    .get(baseURL + "/alarms/getHistoricalAlarms", {
      params: {
        startdate: startdate,
        enddate: enddate,
      },
    })
    .then((res) => {
      console.log("resulkt getHistoricalAlarms", res);
      callback({ data: res, status: "success" });
    })
    .catch((error) => {
      if (error.response) {
        // console.log("in get config Alarms ",error.response)
        // let msg =handleError(error.response.status)
        // // console.log("msg after getting response in catch", msg);
      }
    });
}

export function getSnoozeConfig(projectid, callback) {
  axios
    .get(baseURL + "/alarms/getSnoozeConfig", {
      params: {
        projectid: projectid,
      },
    })
    .then((res) => {
      console.log("resulkt getSnoozeConfig", res);
      callback({ data: res.data, status: "success" });
    })
    .catch((error) => {
      callback({ data: [], status: "failure" });
    });
}

export function getdevicetags1(projectid, projectlist, callback) {
  axios
    .get(baseURL + "/alarms/getTagDeviceStructure", {
      params: {
        projectid: projectid,
        projectlist: projectlist,
      },
    })
    .then((res) => {
      console.log("resulkt getdevicetags OPERATE DATABASE", res);
      callback(res.data, res.status);
    })
    .catch((error) => {
      console.log("error in getdevicetags", error);
      callback(error.message, "error");
    });
}

export function getNotification(tagid, callback) {
  axios
    .get(baseURL + "/alarms/getNotification", {
      params: { tagid },
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      // Always pass the backend response object to the callback
      callback(res.data.data);
    })
    .catch((error) => {
      let errorObj = {
        success: false,
        code: error.response?.status || 500,
        message:
          error.response?.data?.message || "Error fetching notification config",
        error: error.message || error,
        notificationlist: [],
      };
      callback(errorObj);
      if (error.response) {
        let msg = handleError(error.response.status);
        console.log("Error in getNotification:", msg);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error in setting up request:", error.message);
      }
    });
}

export function getNotifcationUserGroups(projectid, projectlist, callback) {
  axios
    .get(baseURL + "/alarms/getNotifcationUserGroups", {
      params: {
        projectid: projectid,
        projectlist: projectlist,
      },
      headers: {
        "Content-Type": "application/json",
        /*"Access-Control-Allow-Origin":
          "https://backend-node-server-cffqhcbvhwangugw.centralindia-01.azurewebsites.net",
        "Access-Control-Allow-Methods": "OPTIONS,POST,GET,PUT,DELETE",*/
      },
    })
    .then((res) => {
      console.log("resulkt getNotifcationUserGroups OPERATE DATABASE", res);
      callback(res.data, res.status);
    })
    .catch((error) => {
      console.log("error in getNotifcationUserGroups", error);
      callback(error.message, "error");
    });
}

//postNotification
export function postNotification(notificationconfig, callback) {
  console.log("NOEW HERE NOTIFICATION", notificationconfig);
  axios
    .post(
      baseURL + "/alarms/postNotificationConfig",
      { notificationconfigparameter: notificationconfig },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    )
    .then((res) => {
      // Backend returns { data: ... } or error structure
      const result = res.data;
      // If backend error structure, pass it to callback
      if (result && result.success === false) {
        callback({
          success: false,
          code: result.code || res.status,
          message: result.message || "Failed to store notification config",
          error: result.error,
          data: result.data || {},
        });
      } else {
        callback({
          success: true,
          code: res.status,
          message: "Notification config stored successfully",
          error: null,
          data: result.data || result,
        });
      }
    })
    .catch((error) => {
      // Always pass a structured error object to callback
      callback({
        success: false,
        code: error.response?.status || 500,
        message:
          error.response?.data?.message || "Error storing notification config",
        error: error.message || error,
        data: {},
      });
      if (error.response) {
        let msg = handleError(error.response.status);
        console.log("Error in postNotification:", msg);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error in setting up request:", error.message);
      }
    });
}

export function getTagDetailsInformation(callback) {
  axios
    .get(baseURL + "/alarms/getTagDetailsInformation", {
      params: {},
      headers: {
        "Content-Type": "application/json",
        /*"Access-Control-Allow-Origin":
          "https://backend-node-server-cffqhcbvhwangugw.centralindia-01.azurewebsites.net",
        "Access-Control-Allow-Methods": "OPTIONS,POST,GET,PUT,DELETE",*/
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getDeviceDetailsInformation(callback) {
  axios
    .get(baseURL + "/alarms/getDeviceDetailsInformation", {
      params: {},
      headers: {
        "Content-Type": "application/json",
        /*"Access-Control-Allow-Origin":
          "https://backend-node-server-cffqhcbvhwangugw.centralindia-01.azurewebsites.net",
        "Access-Control-Allow-Methods": "OPTIONS,POST,GET,PUT,DELETE",*/
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function sendCommand(sendcmd, callback) {
  // const commandToken = arguments.length > 2 ? arguments[2] : null;
  // const requestHeaders = {
  //   "Content-Type": "application/x-www-form-urlencoded",
  // };

  // if (commandToken) {
  //   requestHeaders["X-Command-Token"] = commandToken;
  // }

  axios
    .post(baseURL + "/sendCommand/sendCommand", sendcmd, {
      // headers: requestHeaders,
    })
    .then((res) => {
      callback(res);
    })
    .catch((error) => {
      callback({
        success: false,
        code: error.response?.status || 500,
        message:
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to send command",
      });
    });
}

export function setscheduler(secharray, callback) {
  const commandToken = arguments.length > 2 ? arguments[2] : null;
  const requestHeaders = {
    "Content-Type": "application/x-www-form-urlencoded",
  };

  if (commandToken) {
    requestHeaders["X-Command-Token"] = commandToken;
  }

  axios
    .post(baseURL + "/scheduler/setscheduler", secharray, {
      headers: requestHeaders,
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      callback({
        success: false,
        code: error.response?.status || 500,
        message:
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to set scheduler",
      });
    });
}

export function authorizecommand(password, callback) {
  axios
    .post(
      baseURL + "/authorize-command",
      { password: password },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    )
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      callback({
        success: false,
        code: error.response?.status || 500,
        message:
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Command authorization failed",
      });
    });
}

export function getOverviewbarData(callback) {
  //console.log(" in getOverviewbarData data ");
  axios
    .get(baseURL + "/overviewbar/getOverviewbarData", {
      params: {},
      headers: {
        "Content-Type": "application/json",
        /*"Access-Control-Allow-Origin":
      "https://backend-node-server-cffqhcbvhwangugw.centralindia-01.azurewebsites.net",
      "Access-Control-Allow-Methods": "OPTIONS,POST,GET,PUT,DELETE",*/
      },
    })
    .then((res) => {
      //console.log("in device status live", res);
      callback(res);
    });
}

export function getOverviewbarParameterData(orgId, projectId, callback) {
  //console.log(" in getOverviewbarData data ");
  axios
    .get(baseURL + "/overviewbar/getOverviewbarParameterData", {
      params: {
        orgId: orgId,
        projectId: projectId,
      },
      headers: {
        "Content-Type": "application/json",
        /*"Access-Control-Allow-Origin":
      "https://backend-node-server-cffqhcbvhwangugw.centralindia-01.azurewebsites.net",
      "Access-Control-Allow-Methods": "OPTIONS,POST,GET,PUT,DELETE",*/
      },
    })
    .then((res) => {
      console.log("getOverviewbarParameterData-", res);
      callback(res);
    });
}

export function getAuditLogs(
  logtype,
  userid,
  projectid,
  callback,
  startdate,
  enddate,
) {
  axios
    .get(baseURL + "/audit/getauditlogdata", {
      params: {
        LogType: logtype,
        startDate: startdate,
        endDate: enddate,
      },
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function linkDashboardtoTemplate(
  template,
  groupid,
  dashboardid,
  username,
  callback,
) {
  axios
    .post(baseURL + "/report/linkDashboardToTemplate", null, {
      params: {
        template: template,
        dashboardid: dashboardid,
        groupid: groupid,
        username: username,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getLinkedTemplates(dashboard, callback) {
  axios
    .post(baseURL + "/report/linkedTemplates", null, {
      params: {
        dashboard: dashboard,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export var statusMessage;
export var statusCode;

///MAP

export function getHistoricalData(
  orgId,
  projectId,
  storeNameOrCallback,
  callback,
) {
  // Check if third parameter is the callback function or storeName
  let storeName = null;
  let callbackFn = callback;

  if (typeof storeNameOrCallback === "function") {
    callbackFn = storeNameOrCallback;
  } else if (
    typeof storeNameOrCallback === "string" &&
    typeof callback === "function"
  ) {
    storeName = storeNameOrCallback;
  }

  // Ensure we have a valid callback
  if (typeof callbackFn !== "function") {
    return;
  }

  // First, get the visible projects for the map
  getVisibleProjectsForMap(orgId, async (response) => {
    try {
      if (
        response.success &&
        response.projects &&
        response.projects.length > 0
      ) {
        const visibleProjects = response.projects;

        let projectsToFetch = [];

        // If a specific project is requested, check if it's visible
        if (projectId) {
          const specificProject = visibleProjects.find(
            (p) => p.ProjectId === projectId || p.id === projectId,
          );

          if (specificProject) {
            projectsToFetch = [specificProject];
          } else {
            projectsToFetch = visibleProjects;
          }
        } else {
          // Use all visible projects
          projectsToFetch = visibleProjects;
        }

        // For each project, fetch its data
        const projectDataPromises = projectsToFetch.map(
          (project) =>
            new Promise((resolve) => {
              // Extract project ID
              const pid = project.ProjectId || project.id;

              // Prepare parameters for API call
              const params = {
                orgId: orgId,
                projectId: pid,
              };

              // Add storeName if it exists
              if (storeName) {
                params.storeName = storeName;
              }

              // Make API call
              axios
                .get(`${baseURL}/map/getHistoricalData`, {
                  params: params,
                  headers: {
                    "Content-Type": "application/json",
                  },
                })
                .then((response) => {
                  // Combine project data with its details
                  resolve({
                    projectId: pid,
                    organizationId:
                      project.OrganizationID || project.organizationId || orgId,
                    projectName:
                      project.ProjetName || project.name || `Project ${pid}`,
                    projectLocation:
                      project.Projectdetails?.Location ||
                      project.location ||
                      "Unknown",
                    projectState:
                      project.Projectdetails?.State ||
                      project.state ||
                      "Unknown",
                    projectDetails: project.Projectdetails || {},
                    data: response.data.data || [[], []],
                  });
                })
                .catch((error) => {
                  resolve({
                    projectId: pid,
                    organizationId:
                      project.Organizationid || project.organizationId || orgId,
                    projectName:
                      project.Projectname || project.name || `Project ${pid}`,
                    projectLocation:
                      project.Projectdetails?.Location ||
                      project.location ||
                      "Unknown",
                    projectState:
                      project.Projectdetails?.State ||
                      project.state ||
                      "Unknown",
                    projectDetails: project.Projectdetails || {},
                    error: error.message,
                    data: [[], []],
                  });
                });
            }),
        );

        // Wait for all project data to be fetched
        const projectsWithData = await Promise.all(projectDataPromises);

        // Return all the collected data
        callbackFn({
          success: true,
          multipleProjects: projectsWithData.length > 1,
          projects: projectsWithData,
        });

        return;
      } else {
        // console.warn("No visible projects found, falling back to specific project ID");

        // If there are no visible projects but a specific project was requested
        if (projectId) {
          fetchProjectEnergyData(orgId, projectId, storeName, callbackFn);
          return;
        } else {
          // No visible projects and no specific project requested
          callbackFn({
            success: false,
            error: "No visible projects found",
            projects: [],
          });
          return;
        }
      }
    } catch (error) {
      //console.error("Error fetching visible projects:", error);

      // If a specific project was requested, try to fetch it directly
      if (projectId) {
        fetchProjectEnergyData(orgId, projectId, storeName, callbackFn);
      } else {
        callbackFn({
          success: false,
          error: "Failed to fetch visible projects",
          projects: [],
        });
      }
    }
  });
}

export function getMapHistoricalDataWithDateRange(
  orgId,
  projectId,
  tagId,
  deviceId,
  startDate,
  endDate,
  aggregationType = "SUM",
  optionsOrCallback,
  callback,
) {
  let requestOptions = {};
  let callbackFn = callback;

  if (typeof optionsOrCallback === "function") {
    callbackFn = optionsOrCallback;
  } else if (optionsOrCallback && typeof optionsOrCallback === "object") {
    requestOptions = optionsOrCallback;
  }

  if (!orgId || !projectId || !tagId || !deviceId || !startDate || !endDate) {
    if (typeof callbackFn === "function") {
      callbackFn({
        success: false,
        code: 400,
        message:
          "Missing required parameters: orgId, projectId, tagId, deviceId, startDate, endDate",
        data: null,
      });
    }
    return;
  }

  axios
    .get(`${baseURL}/map/getMapHistoricalData`, {
      params: {
        orgId,
        projectId,
        tagId,
        deviceId,
        startDate,
        endDate,
        aggregationType,
        summaryOnly: requestOptions.summaryOnly === true,
        includeDatapoints:
          typeof requestOptions.includeDatapoints === "boolean"
            ? requestOptions.includeDatapoints
            : undefined,
      },
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      const payload = res?.data || {};
      if (typeof callbackFn === "function") {
        callbackFn({
          success: payload.success === true,
          code: payload.code || res.status,
          message: payload.message || "Historical data fetched",
          data: payload.data || null,
        });
      }
    })
    .catch((error) => {
      if (typeof callbackFn === "function") {
        callbackFn({
          success: false,
          code: error.response?.status || 500,
          message:
            error.response?.data?.message ||
            "Network error fetching historical data",
          error: error.message,
          data: null,
        });
      }
    });
}

export function getMapHistoricalDataAsync(
  orgId,
  projectId,
  tagId,
  deviceId,
  startDate,
  endDate,
  aggregationType = "SUM",
  options = {},
) {
  return new Promise((resolve, reject) => {
    getMapHistoricalDataWithDateRange(
      orgId,
      projectId,
      tagId,
      deviceId,
      startDate,
      endDate,
      aggregationType,
      options,
      (response) => {
        if (response?.success) {
          resolve(response.data);
        } else {
          reject(response || { success: false, message: "Unknown error" });
        }
      },
    );
  });
}

export function handleHistoricalDataRequest(req, res) {
  const {
    orgId,
    projectId,
    storeName,
    startDate,
    endDate,
    startTimestamp,
    endTimestamp,
  } = req.query;

  // Validate required parameters
  if (!orgId || !projectId) {
    return res.status(400).json({
      error: "Missing required parameters",
      requiredParams: ["orgId", "projectId"],
    });
  }

  // Call the getHistoricalData function with proper date parameters
  getHistoricalData(orgId, projectId, storeName, startDate, endDate)
    .then((data) => {
      res.json({ data });
    })
    .catch((error) => {
      res.status(500).json({ error: error.message });
    });
}

export function fetchProjectEnergyData(orgId, projectId, storeName, callback) {
  // Prepare parameters
  const params = {
    orgId: orgId,
    projectId: projectId,
  };

  // Add storeName if it exists
  if (storeName) {
    params.storeName = storeName;
  }

  // Make API call
  axios
    .get(`${baseURL}/map/getHistoricalData`, {
      params: params,
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      // Check if we have a valid data structure
      if (res.data && res.data.data && Array.isArray(res.data.data)) {
        // Get project details (async, but we'll just send what we have)
        getAllProjectsByOrganizationId(orgId, (projectsResponse) => {
          let projectDetails = null;

          if (projectsResponse.success && projectsResponse.projects) {
            projectDetails = projectsResponse.projects.find(
              (p) => p.ProjectId === projectId || p.id === projectId,
            );
          }

          // Format the response
          callback({
            success: true,
            multipleProjects: false,
            projects: [
              {
                projectId: projectId,
                projectName:
                  projectDetails?.Projectname ||
                  projectDetails?.name ||
                  `Project ${projectId}`,
                projectLocation:
                  projectDetails?.Projectdetails?.Location ||
                  projectDetails?.location ||
                  "Unknown",
                projectState:
                  projectDetails?.Projectdetails?.State ||
                  projectDetails?.state ||
                  "Unknown",
                data: res.data.data,
              },
            ],
          });
        });
      } else {
        // Try to generate empty but properly formatted data for the callback
        callback({
          success: true,
          multipleProjects: false,
          projects: [
            {
              projectId: projectId,
              projectName: `Project ${projectId}`,
              data: [[], []], // This matches the expected format
            },
          ],
        });
      }
    })
    .catch((error) => {
      callback({
        success: false,
        error: "Failed to fetch historical data",
        projects: [
          {
            projectId: projectId,
            projectName: `Project ${projectId}`,
            data: [[], []], // Return empty data in expected format
          },
        ],
      });
    });
}

export function getAllProjectsByOrganizationId(orgId, callback) {
  axios
    .get(baseURL + "/map/projects", {
      params: {
        organizationId: orgId,
      },
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      callback({ success: false, error: "Failed to fetch projects" });
    });
}

export const getVisibleProjectsForMap = (orgId, callback) => {
  if (!orgId) {
    if (callback) {
      callback({
        success: false,
        error: "Missing organization ID",
        projects: [],
      });
    }
    return;
  }

  // Call the correct endpoint that returns projects WITH their tags already attached
  axios
    .get(`${baseURL}/map/visibleProjectsForMap`, {
      params: { organizationId: orgId },
    })
    .then((response) => {
      if (
        response.data &&
        response.data.success &&
        Array.isArray(response.data.projects)
      ) {
        // Log each project for debugging
        response.data.projects.forEach((project, index) => {
          console.log(
            `   ${index + 1}. ${project.Projectname || project.name}`,
            {
              ProjectId: project.ProjectId || project.id,
              tags: project.selectedTags?.length || 0,
              visible: project.isVisibleOnMap,
            },
          );
        });

        callback({
          success: true,
          projects: response.data.projects,
          count: response.data.count || response.data.projects.length,
        });
      } else {
        callback({
          success: false,
          error: "Invalid response format",
          projects: [],
        });
      }
    })
    .catch((error) => {
      callback({
        success: false,
        error: error.response?.data?.message || error.message,
        statusCode: error.response?.status,
        projects: [],
      });
    });
};
export function updateProjectVisibility(projectId, isVisible, callback) {
  axios
    .put(
      baseURL + "/map/projectVisibility",
      {
        projectId: projectId,
        isVisible: isVisible,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    )
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      callback({
        success: false,
        error: "Failed to update project visibility",
      });
    });
}

export function updateMultipleProjectVisibility(projectSettings, callback) {
  // First get all projects to ensure correct ID mapping
  getAllProjectsByOrganizationId(null, (projectsResponse) => {
    if (!projectsResponse.success || !projectsResponse.projects) {
    } else {
      const projects = projectsResponse.projects;

      // Create a mapping from document id to ProjectId
      const idToProjectIdMap = {};
      projects.forEach((project) => {
        if (project.id && project.ProjectId) {
          idToProjectIdMap[project.id] = project.ProjectId;
        }
      });

      // Update the project settings with correct ProjectIds
      projectSettings = projectSettings.map((setting) => {
        const mappedProjectId =
          idToProjectIdMap[setting.projectId] || setting.projectId;

        if (mappedProjectId !== setting.projectId) {
          console.log(
            `Remapping document id ${setting.projectId} to actual ProjectId ${mappedProjectId}`,
          );
        }

        return {
          ...setting,
          projectId: mappedProjectId,
        };
      });
    }

    axios
      .put(
        baseURL + "/map/updateMultipleProjectVisibility",
        {
          projectSettings: projectSettings,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        callback(res.data);
      })
      .catch((error) => {
        callback({ success: false, error: error.message });
      });
  });
}

// Add this function to your datacollection.js
export function updateProjectVisibilityOne(projectId, isVisible, callback) {
  // First get all projects to ensure correct ID mapping
  getAllProjectsByOrganizationId(null, (projectsResponse) => {
    if (!projectsResponse.success || !projectsResponse.projects) {
    } else {
      const projects = projectsResponse.projects;
      // Try to find the correct ProjectId if we were passed a document id
      const project = projects.find(
        (p) => p.id === projectId || p.ProjectId === projectId,
      );

      if (project && project.ProjectId && project.ProjectId !== projectId) {
        console.log(
          `Remapping document id ${projectId} to actual ProjectId ${project.ProjectId}`,
        );
        projectId = project.ProjectId;
      }
    }

    // Match your backend API's expected format exactly
    const payload = {
      projectId: projectId,
      isVisibleOnMap: isVisible, // Make sure this property name matches what the backend expects
    };

    axios
      .put(`${baseURL}/map/projectVisibility`, payload)
      .then((response) => {
        callback({ success: true, data: response.data });
      })
      .catch((error) => {
        callback({ success: false, error: error.message });
      });
  });
}

export function getMapConfiguration(organizationId, callback) {
  if (!organizationId) {
    callback({
      success: false,
      error: "Organization ID is required",
      config: null,
    });
    return;
  }

  const url = `${baseURL}/map/configuration?organizationId=${organizationId}`;

  axios
    .get(url)
    .then((response) => {
      // Check if we have a valid response
      if (!response.data) {
        callback({
          success: false,
          error: "Empty response from server",
          config: null,
        });
        return;
      }

      const rawConfig = response.data.config;

      if (!rawConfig) {
        callback({
          success: true,
          config: null,
          message: "No saved configuration found",
        });
        return;
      }

      // Extract the data we need
      const normalizeHistoricalDateFields = (tag = {}) => {
        const isoStart =
          typeof tag?.dateRangeISO?.start === "string"
            ? tag.dateRangeISO.start.split("T")[0]
            : null;
        const isoEnd =
          typeof tag?.dateRangeISO?.end === "string"
            ? tag.dateRangeISO.end.split("T")[0]
            : null;

        return {
          ...tag,
          startDate: tag?.startDate || isoStart || null,
          endDate: tag?.endDate || isoEnd || null,
          dateRangeISO:
            tag?.dateRangeISO ||
            (tag?.startDate && tag?.endDate
              ? {
                  start: new Date(tag.startDate).toISOString(),
                  end: new Date(tag.endDate).toISOString(),
                }
              : null),
        };
      };

      const projectSettings = (rawConfig.projectSettings || []).map((setting) => ({
        ...setting,
        selectedTags: Array.isArray(setting?.selectedTags)
          ? setting.selectedTags.map((tag) => normalizeHistoricalDateFields(tag))
          : [],
      }));
      const allSelectedTags = Array.isArray(rawConfig.allSelectedTags)
        ? rawConfig.allSelectedTags.map((tag) => normalizeHistoricalDateFields(tag))
        : [];
      const plantViewMapLabelSelections = Array.isArray(rawConfig.plantViewMapLabelSelections)
        ? rawConfig.plantViewMapLabelSelections.map((entry) => ({
            projectId: String(entry?.projectId || ""),
            projectName: entry?.projectName || "",
            treePathSelected: Array.isArray(entry?.treePathSelected) ? entry.treePathSelected : [],
            selectedPath: Array.isArray(entry?.selectedPath) ? entry.selectedPath : [],
            lastUpdated: entry?.lastUpdated || rawConfig.lastUpdated || null,
          }))
        : [];
      const projectLabelSelected = {
        projectName: rawConfig?.projectLabelSelected?.projectName || "",
        treePathSelected: Array.isArray(rawConfig?.projectLabelSelected?.treePathSelected)
          ? rawConfig.projectLabelSelected.treePathSelected
          : Array.isArray(rawConfig?.projectLabelSelected?.treepathselected)
            ? rawConfig.projectLabelSelected.treepathselected
          : [],
        selectedPath: Array.isArray(rawConfig?.projectLabelSelected?.selectedPath)
          ? rawConfig.projectLabelSelected.selectedPath
          : Array.isArray(rawConfig?.projectLabelSelected?.selectedpath)
            ? rawConfig.projectLabelSelected.selectedpath
          : [],
        lastUpdated:
          rawConfig?.projectLabelSelected?.lastUpdated || rawConfig.lastUpdated || null,
      };

      const projectLabelSelectionsByProject =
        rawConfig?.projectLabelSelectionsByProject && typeof rawConfig.projectLabelSelectionsByProject === "object"
          ? Object.entries(rawConfig.projectLabelSelectionsByProject).reduce((acc, [key, value]) => {
              const normalizedKey = String(key || "").trim();
              if (!normalizedKey || !value || typeof value !== "object") return acc;
              acc[normalizedKey] = {
                projectId: String(value?.projectId || normalizedKey),
                projectName: value?.projectName || "",
                treePathSelected: Array.isArray(value?.treePathSelected)
                  ? value.treePathSelected
                  : [],
                selectedPath: Array.isArray(value?.selectedPath)
                  ? value.selectedPath
                  : [],
                lastUpdated: value?.lastUpdated || rawConfig.lastUpdated || null,
              };
              return acc;
            }, {})
          : {};

      // Log visible projects
      const visibleProjects = projectSettings.filter(
        (setting) => setting.isVisibleOnMap === true,
      );

      if (visibleProjects.length > 0) {
        visibleProjects.forEach((project) => {
          const projectTags = project.selectedTags || [];
        });
      }

      // Return the complete config object
      callback({
        success: true,
        config: {
          id: rawConfig.id,
          Organizationid: rawConfig.Organizationid || organizationId,
          projectSettings: projectSettings,
          allSelectedTags: allSelectedTags,
          plantViewMapLabelSelections,
          projectLabelSelectionsByProject,
          projectLabelSelected,
          defaultZoomState: rawConfig.defaultZoomState || "",
          lastSaved: rawConfig.lastSaved,
          lastUpdated: rawConfig.lastUpdated,
        },
      });
    })
    .catch((error) => {
      if (error.response) {
        // If server returns 404 or says no config found, that's OK - just no config yet
        if (
          error.response.status === 404 ||
          error.response.data?.message?.includes("not found")
        ) {
          callback({
            success: true,
            config: null,
            message: "No saved configuration found",
          });
          return;
        }
      }

      // Real error - server is down or other issue
      callback({
        success: false,
        error: error.response?.data?.message || error.message,
        config: null,
      });
    });
}

export function getPlantViewLabels(organizationId, projectId, callback) {
  if (typeof callback !== "function") {
    return;
  }

  if (!organizationId || !projectId) {
    callback({
      success: false,
      error: "Organization ID and Project ID are required",
      labels: [],
      labelHierarchy: [],
      hierarchyByMainDashboard: [],
      selectedLabels: [],
    });
    return;
  }

  axios
    .get(`${baseURL}/map/plantViewLabels`, {
      params: {
        orgId: organizationId,
        projectId,
      },
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      callback({
        success: true,
        data: response.data,
        labels: response.data?.labels || [],
        labelHierarchy: response.data?.labelHierarchy || response.data?.hierarchyByMainDashboard || [],
        hierarchyByMainDashboard:
          response.data?.hierarchyByMainDashboard || response.data?.labelHierarchy || [],
        selectedLabels: response.data?.selectedLabels || [],
      });
    })
    .catch((error) => {
      callback({
        success: false,
        error: error.response?.data?.message || error.message,
        labels: [],
        labelHierarchy: [],
        hierarchyByMainDashboard: [],
        selectedLabels: [],
      });
    });
}

// Dedicated frontend API for Map Configuration to fetch Plant View dashboard labels
// from backend using explicit orgId + projectId query parameters.
export function getPlantViewLabelsFromDb(organizationId, projectId, callback) {
  getPlantViewLabels(organizationId, projectId, callback);
}

export function savePlantViewLabelSelection(organizationId, projectId, selectedLabels, callback) {
  if (typeof callback !== "function") {
    return;
  }

  if (!organizationId || !projectId) {
    callback({
      success: false,
      error: "Organization ID and Project ID are required",
    });
    return;
  }

  axios
    .post(`${baseURL}/map/plantViewLabels/selection`, {
      orgId: organizationId,
      projectId,
      selectedLabels: Array.isArray(selectedLabels) ? selectedLabels : [],
    })
    .then((response) => {
      callback({
        success: true,
        data: response.data,
        selectedLabels: response.data?.selectedLabels || [],
        labels: response.data?.labels || [],
        labelHierarchy: response.data?.labelHierarchy || response.data?.hierarchyByMainDashboard || [],
        hierarchyByMainDashboard:
          response.data?.hierarchyByMainDashboard || response.data?.labelHierarchy || [],
        message: response.data?.message || "Selected labels saved successfully",
      });
    })
    .catch((error) => {
      callback({
        success: false,
        error: error.response?.data?.message || error.message,
      });
    });
}
export const fetchVisibleProjectsDirectly = async (organizationId) => {
  try {
    // Make direct API call to the endpoint
    const response = await fetch(
      `${baseURL}/map/visibleProjects?organizationId=${organizationId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (!response.ok) {
      throw new Error(`API returned status ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export function getDeviceTagData(
  orgId,
  projectId,
  startDate,
  endDate,
  callback,
) {
  // Validate the callback is a function
  if (typeof callback !== "function") {
    return;
  }

  // Convert dates to epoch for the API
  const startEpoch =
    startDate instanceof Date
      ? Math.floor(startDate.getTime() / 1000)
      : startDate;
  const endEpoch =
    endDate instanceof Date ? Math.floor(endDate.getTime() / 1000) : endDate;

  axios
    .get(`${baseURL}/map/getDeviceTagData`, {
      params: {
        orgId,
        projectId,
        startDate: startEpoch,
        endDate: endEpoch,
      },
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      callback({ success: true, data: response.data });
    })
    .catch((error) => {
      callback({ success: false, error: error.message });
    });
}

export function saveMapConfiguration(organizationId, configData, callback) {
  try {
    // Validate organization ID
    if (!organizationId) {
      callback({
        success: false,
        error: "Organization ID is required",
      });
      return;
    }

    // Extract projectSettings - handle multiple formats
    let projectSettings = [];
    if (Array.isArray(configData.projectSettings)) {
      projectSettings = configData.projectSettings;
    } else if (Array.isArray(configData)) {
      projectSettings = configData;
    } else if (configData.projectSettings) {
      projectSettings = [configData.projectSettings];
    }

    // Extract allSelectedTags
    const allSelectedTags = configData.allSelectedTags || [];
    const projectLabelSelected = configData.projectLabelSelected || {};
    const plantViewMapLabelSelections = Array.isArray(
      configData.plantViewMapLabelSelections,
    )
      ? configData.plantViewMapLabelSelections
      : [];

    const normalizeDateRangeForTag = (tag = {}) => {
      const startDate =
        tag.startDate ||
        (typeof tag?.dateRangeISO?.start === "string"
          ? tag.dateRangeISO.start.split("T")[0]
          : null);
      const endDate =
        tag.endDate ||
        (typeof tag?.dateRangeISO?.end === "string"
          ? tag.dateRangeISO.end.split("T")[0]
          : null);

      return {
        startDate,
        endDate,
        dateRangeISO:
          tag.dateRangeISO ||
          (startDate && endDate
            ? {
                start: new Date(startDate).toISOString(),
                end: new Date(endDate).toISOString(),
              }
            : null),
      };
    };

    // Build project ID mapping if projectData is provided
    const projectIdMap = {};
    if (configData.projectData) {
      const projectDataArray = Array.isArray(configData.projectData)
        ? configData.projectData
        : Object.values(configData.projectData);

      projectDataArray.forEach((project) => {
        if (project && (project.id || project.ProjectId)) {
          const canonicalId =
            project.ProjectId || project.projectId || project.id;

          // Map all ID variations to canonical ID
          if (project.id) projectIdMap[project.id] = canonicalId;
          if (project.ProjectId) projectIdMap[project.ProjectId] = canonicalId;
          if (project.projectId) projectIdMap[project.projectId] = canonicalId;
        }
      });
    }

    // Normalize and clean project settings
    const cleanedProjectSettings = projectSettings.map((setting) => {
      // Get the correct project ID
      const rawProjectId = setting.projectId || setting.id || setting.ProjectId;
      const projectId = projectIdMap[rawProjectId] || rawProjectId;

      // Get tags for this project
      let projectTags = [];
      if (setting.selectedTags && Array.isArray(setting.selectedTags)) {
        projectTags = setting.selectedTags;
      } else {
        // Fallback: filter from allSelectedTags
        projectTags = allSelectedTags.filter(
          (tag) =>
            tag.projectid === projectId || tag.projectid === rawProjectId,
        );
      }

      // Clean tag data
      const cleanedTags = projectTags.map((tag) => {
        const normalizedDateRange = normalizeDateRangeForTag(tag);
        return {
          projectid: tag.projectid || projectId,
          tagid: tag.tagid,
          tagname: tag.tagname,
          tagunit: tag.tagunit || "",
          std_tagname: tag.std_tagname || "",
          tagdatatype: tag.tagdatatype || "",
          device_id: tag.device_id,
          device_name: tag.device_name,
          mode: tag.mode || "0",
          aggregations: Array.isArray(tag.aggregations) ? tag.aggregations : [],
          startDate: normalizedDateRange.startDate,
          endDate: normalizedDateRange.endDate,
          dateRangeISO: normalizedDateRange.dateRangeISO,
        };
      });

      return {
        projectId: projectId,
        isVisibleOnMap: setting.isVisibleOnMap === true,
        isVisible:
          setting.isVisible === true || setting.isVisibleOnMap === true,
        selectedTags: cleanedTags,
      };
    });

    // Clean allSelectedTags array
    const cleanedAllTags = allSelectedTags.map((tag) => {
      const normalizedDateRange = normalizeDateRangeForTag(tag);
      return {
        projectid: tag.projectid,
        tagid: tag.tagid,
        tagname: tag.tagname,
        tagunit: tag.tagunit || "",
        std_tagname: tag.std_tagname || "",
        tagdatatype: tag.tagdatatype || "",
        device_id: tag.device_id,
        device_name: tag.device_name,
        mode: tag.mode || "0",
        aggregations: Array.isArray(tag.aggregations) ? tag.aggregations : [],
        startDate: normalizedDateRange.startDate,
        endDate: normalizedDateRange.endDate,
        dateRangeISO: normalizedDateRange.dateRangeISO,
      };
    });

    const cleanedPlantViewMapLabelSelections = plantViewMapLabelSelections
      .map((entry) => {
        const projectId = entry?.projectId || entry?.ProjectId || entry?.id || "";
        return {
          projectId,
          projectName:
            typeof entry?.projectName === "string"
              ? entry.projectName
              : "",
          treePathSelected: Array.isArray(entry?.treePathSelected)
            ? entry.treePathSelected.filter((label) => typeof label === "string")
            : [],
          selectedPath: Array.isArray(entry?.selectedPath)
            ? entry.selectedPath.filter((label) => typeof label === "string")
            : [],
          lastUpdated:
            typeof entry?.lastUpdated === "string"
              ? entry.lastUpdated
              : new Date().toISOString(),
        };
      })
      .filter((entry) => String(entry.projectId).trim() !== "");

    const cleanedProjectLabelSelectionsByProject = cleanedPlantViewMapLabelSelections.reduce(
      (accumulator, entry) => {
        const projectKey = String(entry.projectId || "").trim();
        if (!projectKey) {
          return accumulator;
        }

        accumulator[projectKey] = {
          projectId: projectKey,
          projectName: entry.projectName || "",
          treePathSelected: Array.isArray(entry.treePathSelected)
            ? entry.treePathSelected
            : [],
          selectedPath: Array.isArray(entry.selectedPath)
            ? entry.selectedPath
            : [],
          lastUpdated: entry.lastUpdated || new Date().toISOString(),
        };

        return accumulator;
      },
      {},
    );

    const cleanedProjectLabelSelected = {
      projectName:
        typeof projectLabelSelected?.projectName === "string"
          ? projectLabelSelected.projectName
          : "",
      treePathSelected: Array.isArray(projectLabelSelected?.treePathSelected)
        ? projectLabelSelected.treePathSelected.filter((label) => typeof label === "string")
        : [],
      selectedPath: Array.isArray(projectLabelSelected?.selectedPath)
        ? projectLabelSelected.selectedPath.filter((label) => typeof label === "string")
        : [],
      mainDashboardLabels: Array.isArray(projectLabelSelected?.mainDashboardLabels)
        ? projectLabelSelected.mainDashboardLabels.filter((label) => typeof label === "string")
        : [],
      subDashboardLabels: Array.isArray(projectLabelSelected?.subDashboardLabels)
        ? projectLabelSelected.subDashboardLabels.filter((label) => typeof label === "string")
        : [],
      lastUpdated:
        typeof projectLabelSelected?.lastUpdated === "string"
          ? projectLabelSelected.lastUpdated
          : new Date().toISOString(),
    };

    // Build final payload
    const payload = {
      organizationId: organizationId,
      projectSettings: cleanedProjectSettings,
      allSelectedTags: cleanedAllTags,
      plantViewMapLabelSelections: cleanedPlantViewMapLabelSelections,
      projectLabelSelectionsByProject: cleanedProjectLabelSelectionsByProject,
      projectLabelSelected: cleanedProjectLabelSelected,
      lastSaved: configData.lastSaved || new Date().toISOString(),
    };

    if (typeof configData.defaultZoomState === "string") {
      payload.defaultZoomState = configData.defaultZoomState;
    }

    // Log summary
    const visibleCount = cleanedProjectSettings.filter(
      (p) => p.isVisibleOnMap,
    ).length;

    // Log each visible project with its tags
    if (visibleCount > 0) {
      cleanedProjectSettings
        .filter((p) => p.isVisibleOnMap)
        .forEach((project) => {});
    }

    // Make the API call
    const url = `${baseURL}/map/configuration`;

    axios
      .post(url, payload)
      .then((response) => {
        const responseConfig = response.data.config || response.data || {};
        callback({
          success: true,
          config: {
            ...responseConfig,
            plantViewMapLabelSelections: Array.isArray(
              responseConfig?.plantViewMapLabelSelections,
            )
              ? responseConfig.plantViewMapLabelSelections
              : cleanedPlantViewMapLabelSelections,
            projectLabelSelected: responseConfig?.projectLabelSelected
              ? responseConfig.projectLabelSelected
              : cleanedProjectLabelSelected,
          },
          message: response.data.message || "Configuration saved successfully",
        });
      })
      .catch((error) => {
        callback({
          success: false,
          error: error.response?.data?.message || error.message,
          statusCode: error.response?.status,
          details: error.response?.data,
        });
      });
  } catch (error) {
    callback({
      success: false,
      error: error.message,
      stack: error.stack,
    });
  }
}

export function mapProjectIdsCorrectly(projects, visibilitySettings) {
  if (
    !projects ||
    !Array.isArray(projects) ||
    !visibilitySettings ||
    !Array.isArray(visibilitySettings)
  ) {
    return visibilitySettings;
  }

  // Create a map of document id to ProjectId
  const idToProjectIdMap = {};
  projects.forEach((project) => {
    if (project.id && project.ProjectId) {
      idToProjectIdMap[project.id] = project.ProjectId;
    }
  });

  // Update the visibility settings with correct ProjectId
  return visibilitySettings.map((setting) => {
    const correctProjectId =
      idToProjectIdMap[setting.projectId] || setting.projectId;
    return {
      ...setting,
      projectId: correctProjectId,
      // Ensure this setting has the correct ProjectId field too for future use
      ProjectId: correctProjectId,
    };
  });
}

// Use this function when saving map configuration
export function prepareProjectSettings(projects, selectedProjects) {
  if (!projects || !Array.isArray(projects)) {
    return [];
  }

  // Create project settings with the correct ProjectId
  return projects.map((project) => {
    const isSelected =
      selectedProjects.includes(project.id) ||
      selectedProjects.includes(project.ProjectId);

    return {
      projectId: project.ProjectId || project.id, // Use ProjectId as primary key
      // For backward compatibility, include both fields
      ProjectId: project.ProjectId || project.id,
      isVisibleOnMap: isSelected,
      selectedTags: [], // Initialize empty tags
    };
  });
}

// Use this function to get the correct project ID for backend operations
export function getCorrectProjectId(projectReference, projectsList) {
  if (!projectsList || !Array.isArray(projectsList)) {
    return projectReference;
  }

  // Try to find the project by either ID
  const project = projectsList.find(
    (p) => p.id === projectReference || p.ProjectId === projectReference,
  );

  // Return the ProjectId if found, otherwise return the original reference
  return project ? project.ProjectId : projectReference;
}

// Helper function to update the getVisibleProjectsForMap function
export function enhanceVisibleProjectsResponse(response, callback) {
  if (response.success && response.projects) {
    // Ensure each project has both id and ProjectId fields properly set
    const enhancedProjects = response.projects.map((project) => {
      return {
        ...project,
        // Ensure ProjectId is set (use id as fallback)
        ProjectId: project.ProjectId || project.id,
        // Ensure id is set (use ProjectId as fallback)
        id: project.id || project.ProjectId,
      };
    });

    callback({
      success: true,
      projects: enhancedProjects,
    });
  } else {
    callback(response);
  }
}

//customer//

const executeCallback = (callback, data) => {
  if (typeof callback === "function") callback(data);
};

const API_BASE_URL = baseURL;
const apiService = {
  // Get full tree or lazy load root level
  getTreeData: async (orgId, options = {}) => {
    try {
      const params = {};

      // Support lazy loading
      if (options.lazyLoad) {
        params.lazyLoad = "true";
        params.page = options.page || 1;
        params.limit = options.limit || 50;
      }

      // Support depth limiting
      if (options.depth) {
        params.depth = options.depth;
      }

      const res = await axios.get(
        `${API_BASE_URL}/organization/getorganizationtree`,
        { params },
      );
      console.log("getTreeData-response", res.data);
      return res.data;
    } catch (error) {
      return handleError(error);
    }
  },

  // Load children of a specific organization (for lazy loading)
  getTreeChildren: async (orgId, options = {}) => {
    try {
      const params = {
        lazyLoad: "true",
        page: options.page || 1,
        limit: options.limit || 50,
        orgId: orgId,
      };

      const res = await axios.get(
        `${API_BASE_URL}/organization/getorganizationtree`,
        { params },
      );
      console.log("getTreeChildren-response", res.data);
      return res.data;
    } catch (error) {
      return handleError(error);
    }
  },

  // Load more items (pagination)
  getTreeDataPage: async (page, limit = 50) => {
    try {
      const params = {
        lazyLoad: "true",
        page: page,
        limit: limit,
      };

      const res = await axios.get(
        `${API_BASE_URL}/organization/getorganizationtree`,
        { params },
      );
      console.log("getTreeDataPage-response", res.data);
      return res.data;
    } catch (error) {
      return handleError(error);
    }
  },

  getTreeDataDirectLinkage: async (projId, orgId) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/organization/getOrgtreeDirectLinkage`,
      );
      return res.data;
    } catch (error) {
      return handleError(error);
    }
  },
  getTreeByOrganizationId: async (organizationId) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/organization/getTreeById`);
      return res.data;
    } catch (error) {
      return handleError(error);
    }
  },

  addorganization: async (parentId = "", newNode) => {
    try {
      const newnode = { ...newNode, parentOrgId: parentId };
      const res = await axios.post(
        `${API_BASE_URL}/organization/addorganization`,
        newnode,
      );
      return res.data;
    } catch (error) {
      return handleError(error);
    }
  },
  addProject: async (parentId, newNode) => {
    try {
      const newnode = { ...newNode, Organizationid: parentId };
      const res = await axios.post(
        `${API_BASE_URL}/organization/addproject`,
        newnode,
      );
      return res.data;
    } catch (error) {
      return handleError(error);
    }
  },
  editOrganization: async (organizationId, updatedNode) => {
    try {
      const res = await axios.put(
        `${API_BASE_URL}/organization/editorganization`,
        updatedNode,
      );
      return res.data;
    } catch (err) {
      return handleError(err);
    }
  },
  editProject: async (nodeId, updatedNode) => {
    try {
      const res = await axios.put(
        `${API_BASE_URL}/organization/editproject`,
        updatedNode,
      );
      return res.data;
    } catch (err) {
      return handleError(err);
    }
  },

  deleteProject: async (projectId, projectName) => {
    try {
      const res = await axios.delete(
        `${API_BASE_URL}/organization/deleteproject`,
        {
          data: { projectId: projectId, projectName: projectName },
        },
      );
      return res.data;
    } catch (err) {
      return err;
    }
  },
  deleteOrganization: async (orgName, organizationId) => {
    try {
      const res = await axios.delete(
        `${API_BASE_URL}/organization/deleteorganization?organizationId=${organizationId}&orgName=${encodeURIComponent(orgName)}`,
      );
      return res.data;
    } catch (err) {
      return handleError(err);
    }
  },
};

const userAccessService = {
  getUsersByOrg: async (organizationid) => {
    try {
      const usersLst = await axios.get(
        `${API_BASE_URL}/usermanagement/getUserDetailsOrganizationIDWise?organizationid=${organizationid}`,
      );
      return usersLst.data.data;
    } catch (error) {
      return handleError(error);
    }
  },
  getUsersByProject: async (id) => {
    try {
      const usersLst = await axios.get(
        `${API_BASE_URL}/usermanagement/getUserDetailsProjectIDWise?projectid=${id}`,
      );
      return usersLst.data.data;
    } catch (error) {
      return handleError(error);
    }
  },
  addUser: async (userObj) => {
    console.log("addUser-userObj-123", userObj);
    try {
      const res = await axios.post(
        `${API_BASE_URL}/usermanagement/createUser`,
        userObj,
      );
      if (res.status === 201) {
        return {
          success: true,
          data: res.data.data,
          message: res.data.message || "User added successfully.",
        };
      } else {
        return {
          success: false,
          message: res.data.message || "Failed to add user.",
        };
      }
    } catch (error) {
      console.error("Error adding user:", error);
      return {
        success: false,
        message:
          error.response?.data?.message ||
          "An error occurred while adding the user.",
      };
    }
  },
  updateUser: async (userObj) => {
    try {
      const res = await axios.put(
        `${API_BASE_URL}/usermanagement/updateUser`,
        userObj,
      );
      if (res.status === 200) {
        return {
          success: true,
          data: res.data.data,
          message: res.data.message || "User updated successfully.",
        };
      } else {
        return {
          success: false,
          message: res.data.message || "Failed to update user.",
        };
      }
    } catch (error) {
      console.error("Error updating user:", error);
      return {
        success: false,
        message:
          error.response?.data?.message ||
          "An error occurred while updating the user.",
      };
    }
  },
  deleteUser: async (userObj) => {
    try {
      const res = await axios.delete(
        `${API_BASE_URL}/usermanagement/deleteUser`,
        { data: userObj },
      );
      if (res.status === 200) {
        return {
          success: true,
          data: res.data.data,
          message: res.data.message || "User deleted successfully.",
        };
      } else {
        return {
          success: false,
          data: [],
          message: res.data.message || "Failed to delete user.",
        };
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      return {
        success: false,
        data: [],
        message:
          error.response?.data?.message ||
          "An error occurred while deleting the user.",
      };
    }
  },

  createUserRoles: async (roleObj) => {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/usermanagement/createUserRoles`,
        roleObj,
      );

      return res.data;
    } catch (error) {
      return handleError(error);
    }
  },
  updateUserRoles: async (roleObj) => {
    try {
      const res = await axios.put(
        `${API_BASE_URL}/usermanagement/upsertUserRole`,
        roleObj,
      );
      return res.data;
    } catch (error) {
      return handleError(error);
    }
  },
  deleteRole: async (roleObj) => {
    try {
      const res = await axios.delete(
        `${API_BASE_URL}/usermanagement/deleteUserRole`,
        { data: roleObj },
      );
      if (res.status === 200) {
        return {
          success: true,
          data: res.data.data,
          message: res.data.message || "User deleted successfully.",
        };
      } else {
        return {
          success: false,
          data: [],
          message: res.data.message || "Failed to delete user.",
        };
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      return {
        success: false,
        data: [],
        message:
          error.response?.data?.message ||
          "An error occurred while deleting the user.",
      };
    }
  },
  getRolesByUserDetails: async (projId, orgId, roleId) => {
    const query = `?currentUserProjectID=${projId}&currentUserOrganizationID=${orgId}&currentUserRoleID=${roleId}`;
    try {
      const res = await axios.get(
        `${API_BASE_URL}/usermanagement/getUserRoles/${query}`,
      );
      console.log("res-getRolesByUserDetails", res);
      return res.data;
    } catch (error) {
      return handleError(error);
    }
  },
  getAllRolesByUserDetails: async (projId, orgId, roleId) => {
    const query = `?currentUserProjectID=${projId}&currentUserOrganizationID=${orgId}`;
    try {
      const res = await axios.get(
        `${API_BASE_URL}/usermanagement/getAllUserRoles/${query}`,
      );
      return res.data;
    } catch (error) {
      return handleError(error);
    }
  },

  createUserModule: async (moduleObj) => {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/usermanagement/createModulePermissions`,
        moduleObj,
      );
      return res.data;
    } catch (error) {
      return handleError(error);
    }
  },
  updateUserModule: async (updatedModuleObj) => {
    try {
      const res = await axios.put(
        `${API_BASE_URL}/usermanagement/updateModulePermissions`,
        updatedModuleObj,
      );
      return res.data;
    } catch (error) {
      return handleError(error);
    }
  },
  getModulesByUserDetails: async (roleId) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/usermanagement/getLevelwisePermissions`,
      );
      return res.data;
    } catch (error) {
      return {
        status: "failure",
        message: "Modulewise Permissions not fetched successfully.",
        data: [],
        error: error?.message,
      };
    }
  },
  getAllModules: async (roleId) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/usermanagement/getAllPermissions`,
      );
      return res.data;
    } catch (error) {
      return {
        status: "failure",
        message: "Modulewise Permissions not fetched successfully.",
        data: [],
        error: error?.message,
      };
    }
  },
  deleteUserModule: async (moduleObj) => {
    try {
      const res = await axios.delete(
        `${API_BASE_URL}/usermanagement/deleteModulePermissions`,
        { data: moduleObj },
      );
      console.log("res-deleteUserModule", res);
      if (res.status === 200) {
        return {
          success: true,
          message: res.data.message || "Module deleted successfully.",
        };
      } else {
        return {
          success: false,
          message: res.data.message || "Failed to delete Module.",
        };
      }
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          "An error occurred while deleting the Module.",
      };
    }
  },

  getLoginPolicyOptions: async (roleId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/usermanagement/getLevelwiseLoginDefaultOptions`,
      );
      if (response.status === 200) {
        console.log("login policy settings", response.data);
        return {
          success: true,
          data: response.data,
          message:
            response.data || "Login policy settings fetched successfully.",
        };
      } else {
        return {
          success: false,
          message: response.data || "Failed to fetch login policy settings.",
        };
      }
    } catch (error) {
      console.error("Error fetching login policy settings:", error);
      return {
        success: false,
        message:
          error.response?.data ||
          "An error occurred while fetching login policy settings.",
      };
    }
  },
  getLoginPolicySettings: async (orgId, projId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/usermanagement/getLoginPolicySettings`,
      );
      if (response.status === 200) {
        console.log("login policy settings", response.data);
        return {
          success: true,
          data: response.data,
          message:
            response.data || "Login policy settings fetched successfully.",
        };
      } else {
        return {
          success: false,
          message: response.data || "Failed to fetch login policy settings.",
        };
      }
    } catch (error) {
      console.error("Error fetching login policy settings:", error);
      return {
        success: false,
        message:
          error.response?.data ||
          "An error occurred while fetching login policy settings.",
      };
    }
  },
  savePolicySettings: async (finalObj) => {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/usermanagement/upsertLoginPolicySettings`,
        finalObj,
      );
      if (response.status === 200) {
        return {
          success: true,
          message:
            response.data.message ||
            "Login policy settings saved successfully.",
        };
      } else {
        return {
          success: false,
          message:
            response.data.message || "Failed to save login policy settings.",
        };
      }
    } catch (error) {
      console.error("Error saving login policy settings:", error);
      return {
        success: false,
        message:
          error.response?.data?.message ||
          "An error occurred while saving login policy settings.",
      };
    }
  },
  getAvailableProjects: async (projId, orgId, roleId) => {
    console.log(
      "getAvailableProjects : projId, orgId, roleId",
      projId,
      orgId,
      roleId,
    );
    const query = `?currentUserProjectID=${projId}&currentUserOrganizationID=${orgId}&currentUserRoleID=${roleId}`;
    try {
      const res = await axios.get(
        `${API_BASE_URL}/usermanagement/getAvailableProjects`,
      );
      return res.data;
    } catch (error) {
      return handleError(error);
    }
  },
};

export function user(username, projectId) {
  console.log("Logging out", { username, projectId });
  axios
    .post(
      baseURL + "/login/logout",
      null,
      { params: { username: username, projectId: projectId } },

      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    )
    .then((res) => {
      console.log("res postalarmconfig restclieby", res);
    });
}

export function getcompliancerows(projectId, callback) {
  axios
    .get(baseURL + "/compliance/rows", {
      params: {
        projectId: projectId,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getcompliancerowtags(projectId, deviceId, callback) {
  axios
    .get(baseURL + "/compliance/rowTags", {
      params: {
        projectId: projectId,
        deviceId: deviceId,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export async function ForgetPassword(email) {
  try {
    const res = await axios.post(`${baseURL}/login/forgetPassword`, { email });
    return res.data; // return success response directly
  } catch (err) {
    console.error("Forget Password error", err.response?.data || err);
    return { error: "Error sending email, please try again later" };
  }
}

export function ValidateResetPwd(email, callback) {
  axios
    .post(baseURL + "/login/validate-reset-token", { email })
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.error("Forget Password error", err);
      callback({ error: "Error sending email, please try again later" });
    });
}

export const ResetPassword = async (
  email,
  token,
  newPassword,
  confirmPassword,
) => {
  try {
    const response = await axios.post(baseURL + "/login/resetPassword", {
      email,
      token,
      newPassword,
      confirmPassword,
    });
    return response.data;
  } catch (err) {
    console.error("Reset Password error", err.response?.data || err);
    return err.response?.data || { error: err.message };
  }
};

export async function ValidateResetToken(token, email) {
  try {
    const response = await axios.post(baseURL + "/login/validate-reset-token", {
      token,
      email,
    });
    return response.data; // should return { valid: true/false }
  } catch (err) {
    console.error("Validate Reset Token error", err.response?.data || err);
    return { valid: false, error: "Invalid or expired reset link" };
  }
}

export function getTemplateGroups(code, callback) {
  axios
    .get(baseURL + "/report/getTemplateGroups", {
      params: {
        code: code,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function addTemplateGroup(name, code, callback) {
  console.log("Adding template group:", name, code);
  axios
    .post(baseURL + "/report/addTemplateGroup", null, {
      params: {
        name: name,
        code: code,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function addTemplateSubgroup(key, name, code, callback) {
  axios
    .post(baseURL + "/report/addTemplateSubgroup", null, {
      params: {
        key: key,
        name: name,
        code: code,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function editTemplateGroup(key, name, code, callback) {
  axios
    .post(baseURL + "/report/editTemplateGroup", null, {
      params: {
        key: key,
        name: name,
        code: code,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function deleteTemplateGroup(key, code, callback) {
  axios
    .post(baseURL + "/report/deleteTemplateGroup", null, {
      params: {
        key: key,
        code: code,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getTemplateGroupTree(code, callback) {
  axios
    .get(baseURL + "/report/getTemplateGroupTree", {
      params: {
        code: code,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getTemplateTree(callback) {
  axios
    .get(baseURL + "/report/getTemplateTree", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getEntireTemplateTree(callback) {
  axios
    .get(baseURL + "/report/getEntireTemplateTree", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    });
}

export function deleteTemplate(groupId, templateId, code, callback) {
  axios
    .post(baseURL + "/report/deleteTemplate", null, {
      params: {
        groupId: groupId,
        templateId: templateId,
        code: code,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getdashboardtemplatedetails(callback) {
  axios
    .get(baseURL + "/report/dashboardtemplatedetails", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    });
}

export function unlinkDashboardtoTemplate(
  template,
  groupid,
  dashboardid,
  username,
  callback,
) {
  axios
    .post(baseURL + "/report/unlinkDashboardToTemplate", null, {
      params: {
        template: template,
        dashboardid: dashboardid,
        groupid: groupid,
        username: username,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function addTemplate(template, code, callback) {
  console.log("Adding template:", template);
  axios
    .post(baseURL + "/report/addTemplate", null, {
      params: {
        template: JSON.stringify(template), // Convert object to string
        code: code,
      },
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      console.error("Error adding template:", error);
    });
}

export function editTemplate(newTemplate, code, callback) {
  axios
    .post(baseURL + "/report/editTemplate", null, {
      params: {
        // Convert object to string
        newTemplate: JSON.stringify(newTemplate),
        code: code,
      },
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      console.error("Error adding template:", error);
    });
}

export function getTagnames(dynamic, callback) {
  axios
    .get(baseURL + "/report/getTagname", {
      params: {
        dynamic: dynamic,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getTemplateDetails(templateid, groupid, callback) {
  axios
    .get(baseURL + "/report/templatedetails", {
      params: {
        templateid: templateid,
        groupid: groupid,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getGeneratedReports(username, callback) {
  axios
    .post(baseURL + "/report/generatedReports", null, {
      params: {
        username: username,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getUserGroupReports(callback) {
  axios
    .post(baseURL + "/report/getUserGroups", null, {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    });
}

export function emailReport(id, selectedUsers, callback) {
  axios
    .post(baseURL + "/report/emailreport", null, {
      params: {
        id: id,
        selectedUsers: selectedUsers,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function saveDeviceTypes(data, type, callback) {
  axios
    .post(baseURL + "/devicetypes/saveDeviceTypes", {
      data: data,
      type: type,
    })
    .then((res) => {
      callback(res, data, type);
    });
}

export function saveDeviceTypeProjects(
  projectlist,
  allproject,
  indexlevel,
  callback,
) {
  axios
    .post(baseURL + "/devicetypes/saveDeviceTypeProjects", {
      projectlist: projectlist,
      allproject: allproject,
      indexlevel: indexlevel,
    })
    .then((res) => {
      callback(res, projectlist, allproject);
    });
}

export function deleteDeviceType(deleteArr, callback) {
  axios
    .post(baseURL + "/devicetypes/deleteDeviceType", {
      deleteArr: deleteArr,
    })
    .then((res) => {
      callback(res);
    });
}

export function getDevicesTypes(callback) {
  axios
    .get(baseURL + "/devicetypes/getDevicesTypes", {
      params: {},
    })
    .then((res) => {
      callback(res);
    });
}

export function getDeviceTypesList(callback) {
  axios
    .get(baseURL + "/devicetypes/getDeviceTypesList", {
      params: {},
    })
    .then((res) => {
      callback(res);
    });
}

export function getFrequencyAndFunctionList(callback) {
  axios
    .get(baseURL + "/storage/getFrequencyAndFunctionList", {
      params: {},
    })
    .then((res) => {
      callback(res);
    });
}

export function saveStorageGroup(data, callback) {
  axios
    .post(baseURL + "/storage/saveStorageGroup", { data: data })
    .then((res) => {
      callback(res, data);
    });
}

export function getStorageGroups(callback) {
  axios.get(baseURL + "/storage/getStorageGroups").then((res) => {
    callback(res);
  });
}

export function deleteStorageGroup(deletegrp, callback) {
  axios
    .post(baseURL + "/storage/deleteStorageGroup", { deletegrp: deletegrp })
    .then((res) => {
      callback(res);
    });
}

export function saveStorage(storage, callback) {
  axios
    .post(baseURL + "/storage/saveStorage", { storage: storage })
    .then((res) => {
      callback(res);
    });
}

export function getStorage(callback) {
  axios.get(baseURL + "/storage/getStorage").then((res) => {
    callback(res);
  });
}

export function getStorageGroupsList(callback) {
  axios.get(baseURL + "/storage/getStorageGroupsList").then((res) => {
    callback(res);
  });
}

export function getStoragePeriodList(callback) {
  axios.get(baseURL + "/storage/getStoragePeriodList").then((res) => {
    callback(res);
  });
}

export function devicelibrarycreate(deviceinformation, ismeter, callback) {
  axios
    .post(baseURL + "/devicelibrary/createDeviceLibrary", {
      deviceinformation: deviceinformation,
      ismeter: ismeter,
    })
    .then((res) => {
      callback(res);
    });
}

export function getlibrarydevices(callback) {
  axios
    .get(baseURL + "/devicelibrary/getlibrarydevices", {
      params: {},
    })
    .then((res) => {
      callback(res.data.devices);
    });
}

export function librarytagdelete(deviceId, deleteTags, callback) {
  axios
    .post(baseURL + "/devicelibrary/librarytagdelete", {
      deviceId: deviceId,
      deleteTags: deleteTags,
    })
    .then((res) => {
      callback(res);
    });
}

export function librarydevicedelete(deletedeviceno, callback) {
  axios
    .post(baseURL + "/devicelibrary/deleteLibraryDevice", {
      deletedeviceno: deletedeviceno,
    })
    .then((res) => {
      callback(res);
    });
}

export function getDeviceLibraryList(callback) {
  axios
    .get(baseURL + "/devicelibrary/getDeviceLibraryList", {
      params: {},
    })
    .then((res) => {
      callback(res);
    });
}

export function getDeviceLibraryByIdList(id, ifstd, callback) {
  axios
    .get(baseURL + "/devicelibrary/getDeviceLibraryByIdList", {
      params: { id: id, ifstd: ifstd },
    })
    .then((res) => {
      callback(res);
    });
}

export function saveSubscriptionPlan(planInfo, callback) {
  axios.post(baseURL + "/subscriptionPlan/saveSubscriptionPlan", 
    { planInfo: planInfo })
    .then((res) => {
      callback(res, planInfo);
    });
} 

export function deleteSubscriptionPlans(ids, callback) {
  axios.post(baseURL + "/subscriptionPlan/deleteSubscriptionPlans", 
    { ids: ids })
    .then((res) => {
      callback(res, ids);
    });
} 
export function getSubscriptionPlans(callback) {
  axios.get(baseURL + "/subscriptionPlan/getSubscriptionPlans")
    .then((res) => {
      callback(res);
    });
} 

export function getFeatureList(callback) {
  axios.get(baseURL + "/subscriptionPlan/getFeatureList")
    .then((res) => {
      callback(res);
    });
}

export function getSubscriptionPlanList(callback) {
  axios.get(baseURL + "/subscriptionPlan/getSubscriptionPlanList")
    .then((res) => {
      callback(res);
    });
} 

export function saveSubscription(subscriptionInfo, callback) {
  axios.post(baseURL + "/subscription/saveSubscription", 
    { subscriptionInfo: subscriptionInfo })
    .then((res) => {
      callback(res, subscriptionInfo);
    });
}

export function saveSubscriptionOtherRoles(subscriptionInfo, callback) {
  axios.post(baseURL + "/subscription/saveSubscriptionOtherRoles", 
    { subscriptionInfo: subscriptionInfo })
    .then((res) => {
      callback(res, subscriptionInfo);
    });
}

export function getSubscriptions(callback) {
  axios.get(baseURL + "/subscription/getSubscriptions")
    .then((res) => {
      callback(res);
    });
}

export function getOrgandProjectList(callback) {
  axios.get(baseURL + "/subscription/getOrgandProjectList")
    .then((res) => {
      callback(res);
    });
}

export function getProjectList(callback) {
  axios.get(baseURL + "/subscription/getProjectList")
    .then((res) => {
      callback(res);
    });
}

export function deleteSubscriptions(ids, callback) {
  axios.post(baseURL + "/subscription/deleteSubscriptions", 
    { ids: ids })
    .then((res) => {
      callback(res, ids);
    });
} 

export function getOrgSubscriptions(callback) {
  axios.get(baseURL + "/subscription/getOrgSubscriptions")
    .then((res) => {
      callback(res);
    });
}

export function saveSubscriptionFeature(featureInfo, callback) {
  axios.post(baseURL + "/subscriptionFeature/saveSubscriptionFeature", 
    { featureInfo: featureInfo })
    .then((res) => {
      callback(res, featureInfo);
    });
}

export function getSubscriptionFeatures(callback) {
  axios.get(baseURL + "/subscriptionFeature/getSubscriptionFeatures")
    .then((res) => {
      callback(res);
    });
}

export function getSubscriptionDetails(callback) {
  console.log("Fetching subscription details...");
  console.log("Base URL:", baseURL);
  axios.get(baseURL + "/subscription/getSubscriptionDetails")
    .then((res) => {
      callback(res);
    });
}

// Function to fetch component data
export async function fetchData() {
  try {
    const token = localStorage.getItem("authToken"); // Adjust this line based on where you store the token
    const response = await fetch(`${baseURL}/digital-twin/component-data`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

// Function to fetch mappings
export async function fetchMappings() {
  try {
    const response = await axios.get(`${baseURL}/digital-twin/mappings`);
    return response.data;
  } catch (error) {
    console.error("Error fetching mappings:", error);
    throw error;
  }
}

// Function to create a new mapping
export async function createMapping(mapping) {
  try {
    const response = await axios.post(
      `${baseURL}/digital-twin/mappings`,
      mapping,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating mapping:", error);
    throw error;
  }
}

export function postoverviewconfig(overviewBarGroups, callback) {
  axios
    .post(
      baseURL + "/overview/postOverviewConfig",
      {
        overviewBarGroups: JSON.stringify({ overviewBarGroups }),
        process: "ALERT_CREATION",
        timestamp: Date.now(),
        userid: "",
        action: "CREATE",
        old_value: "",
        new_value: "",
        comment: "Alert rule is created",
        projectid: "",
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    )
    .then((res) => {
      callback(res, res.status);
    })
    .catch((error) => {
      callback(error.response, error.status);
    });
}

// Fetch overview bar config by project ID
// export function getOverviewConfig(startdate, enddate, dateselected, callback) {
//   axios
//     .get(baseURL + "/overview/getOverviewConfig", {
//       params: {
//         startdate: startdate,
//         enddate: enddate,
//         dateselected: dateselected
//        },
//       headers: {
//         "Content-Type": "application/json",
//       },
//     })
//     .then((res) => {
//       callback(res, res.status);
//     })
//     .catch((error) => {
//       callback(error.response, 'error');
//     });
// }
// Fetch overview bar config by project ID

export function getOverviewConfig(callback) {
  axios
    .get(baseURL + "/overview/getOverviewConfig", {
      params: {},
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      callback(res);
    })
    .catch((error) => {
      console.error("Error Overview Config::", error);
      callback(error);
    });
}
// Fetch overview bar config by project ID
// export function getOverviewConfig(startdate, enddate, dateselected, callback) {
//   axios
//     .get(baseURL + "/overview/getOverviewConfig", {
//       params: {
//         startdate: startdate,
//         enddate: enddate,
//         dateselected: dateselected
//        },
//       headers: {
//         "Content-Type": "application/json",
//       },
//     })
//     .then((res) => {
//       callback(res, res.status);
//     })
//     .catch((error) => {
//       callback(error.response, 'error');
//     });
// }

export function getOverviewConfigAll(
  startdate,
  enddate,
  dateselected,
  callback,
) {
  axios
    .get(baseURL + "/overview/getOverviewConfigAll", {
      params: {
        startdate: startdate,
        enddate: enddate,
        dateselected: dateselected,
      },
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      callback(res, res.status);
    })
    .catch((error) => {
      callback(error.response, "error");
    });
}

export function addGroup(groupName, callback) {
  axios
    .get(baseURL + "/group/addGroup", {
      params: {
        groupName: groupName,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getGroup(callback) {
  axios
    .get(baseURL + "/group/getGroup", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    });
}

// Get audit processes for a project
export const getAuditProcesses = (callback) => {
  axios
    .get(`${baseURL}/auditconfig/processes`, {})
    .then((res) => {
      callback(res, res.status);
    })
    .catch((error) => {
      console.error("Error fetching audit processes:", error);
      callback(
        error.response || { message: "Network error" },
        error.response?.status || "error",
      );
    });
};

// Get master audit processes for a project
export const getMasterAuditProcesses = (callback) => {
  axios
    .get(`${baseURL}/auditconfig//masterprocesses`, {})
    .then((res) => {
      callback(res, res.status);
    })
    .catch((error) => {
      console.error("Error fetching audit processes:", error);
      callback(
        error.response || { message: "Network error" },
        error.response?.status || "error",
      );
    });
};

// Add a new audit process
export const addAuditProcess = (processData, userId, callback) => {
  axios
    .post(`${baseURL}/auditconfig/processes`, processData, {
      params: {
        userId: userId,
      },
    })
    .then((res) => {
      callback(res, res.status);
    })
    .catch((error) => {
      console.error("Error adding audit process:", error);
      callback(
        error.response || { message: "Network error" },
        error.response?.status || "error",
      );
    });
};

// Delete an audit process
export const deleteAuditProcess = (processId, callback) => {
  axios
    .delete(`${baseURL}/auditconfig/processes/${processId}`, {
      params: {},
    })
    .then((res) => {
      callback(res, res.status);
    })
    .catch((error) => {
      console.error("Error deleting audit process:", error);
      callback(
        error.response || { message: "Network error" },
        error.response?.status || "error",
      );
    });
};

// ============================================================================
// COMMISSION INTEGRATION APIs
// ============================================================================

// Login to Commission module
export const loginToCommission = (loginData, callback) => {
  axios
    .post(`${baseURL}/operate-integration/login`, loginData, {})
    .then((res) => {
      callback(res, res.status);
    })
    .catch((error) => {
      console.error("Error logging into Commission:", error);
      callback(
        error.response || { message: "Network error" },
        error.response?.status || "error",
      );
    });
};

// Sync Commission data to Operate
export const syncCommissionData = (syncData, callback) => {
  axios
    .post(`${baseURL}/operate-integration/sync-commission-data`, syncData, {})
    .then((res) => {
      callback(res, res.status);
    })
    .catch((error) => {
      console.error("Error syncing Commission data:", error);
      callback(
        error.response || { message: "Network error" },
        error.response?.status || "error",
      );
    });
};

export function exportPdfReport(
  reportUrl,
  startDate,
  endDate,
  currDate,
  callback,
) {
  axios
    .post(baseURL + "/report/export-pdf", null, {
      params: {
        reportUrl: reportUrl,
        startDate: startDate,
        endDate: endDate,
        currDate: currDate,
      },
    })
    .then((res) => {
      callback(res);
    });
}

export function exportAndEmailReport(reportUrl, callback) {
  axios
    .post(baseURL + "/report/export-pdf-email", null, {
      params: {
        reportUrl: reportUrl,
      },
    })
    .then((res) => {
      callback(res);
    });
}

export function generateReportStandard(
  dateselected,
  templateId,
  startDT,
  endDT,
  devices,
  orientation,
  docType,
  callback,
) {
  axios
    .post(baseURL + "/report/generateReportStandard", null, {
      responseType: "arraybuffer",
      headers: {
        Accept:
          docType === "Excel"
            ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            : "application/pdf",
      },
      params: {
        dateselected: dateselected,
        templateId: templateId,
        startDT: startDT,
        endDT: endDT,
        devices: devices,
        orientation: orientation,
        docType: docType,
      },
    })
    .then((res) => {
      callback(res.data, docType);
    });
}

export function viewGeneratedReport(id, callback) {
  axios
    .post(baseURL + "/report/viewGeneratedReport", null, {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
      },
      params: {
        id: id,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

// export function getchatbottoken(callback) {
//   return axios.get("https://ems-cloud-webapp.azurewebsites.net/chatbot/bot/token", {
//     params: {},
//   });
// }
export function getchatbottoken() {
  const token =
    sessionStorage.getItem("Token") || localStorage.getItem("token");
  const apiUrl = process.env.REACT_APP_BOT_API;
  
  return axios.get(
    `${apiUrl}/chatbot/bot/token`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
}

// CUSTOMER
export function getAllCustomers(callback) {
  axios
    .get(baseURL + "/customerroute/customers", {
      params: {},
    })
    .then((res) => {
      const formattedCustomers =
        res.data?.customers?.map((customer) => ({
          id: customer.id,
          data: {
            customerId: customer.customerId,
            deviceId: customer.deviceId,
            tagId: customer.tagId,
            firstName: customer.firstName,
            middleName: customer.middleName,
            lastName: customer.lastName,
            email: customer.email,
            phone: customer.phone,
            customerType: customer.customerType,
            isActive: customer.isActive ?? true,
            addressLine1: customer.addressLine1,
            addressLine2: customer.addressLine2,
            city: customer.city || "",
            state: customer.state || "",
            country: customer.country || "",
            postalCode: customer.postalCode || "",
            poleNo: customer.poleNo || "",
            prepaid: customer.prepaid || "No",
            accountCreationDate: customer.accountCreationDate || "",
            billingCycle: customer.billingCycle,
            billingCycleStart: customer.billingCycleStart || "",
            billingCycleEnd: customer.billingCycleEnd || "",
            removalDate: customer.removalDate,
            reasonForRemoval: customer.reasonForRemoval,
            initialMeterReading: customer.initialMeterReading || "",
            finalMeterReading: customer.finalMeterReading || "",
            previousMeterIds: customer.previousMeterIds,
            sanctionLoad: customer.sanctionLoad,
            tariffId: customer.tariffId || "",
            accountStatus: customer.accountStatus,
          },
        })) || [];
      const result = { state: true, customers: formattedCustomers };
      callback(result);
    })
    .catch((error) => {
      callback({
        state: false,
        customers: [],
        message: error.message || "Error fetching customers",
      });
    });
}

export function createCustomer(payload, callback) {
  axios
    .post(baseURL + "/customerroute/create", payload, {
      headers: { "Content-Type": "application/json" },
    })
    .then((res) => {
      if (!res.data || !res.data.customer) {
        callback({
          success: false,
          error: "Invalid server response: No customer data returned",
        });
        return;
      }
      callback({
        success: true,
        customer: { id: res.data.customer.id, data: res.data.customer.data },
      });
    })
    .catch((error) => {
      callback({
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "Failed to create customer",
      });
    });
}

export function updateCustomer(customerId, updateData, callback) {
  axios
    .put(`${baseURL}/customerroute/${customerId}`, updateData)
    .then((res) => {
      if (res.data?.success) {
        callback({ success: true, customer: res.data.customer });
      } else {
        callback({
          success: false,
          message: res.data?.message || "Customer update failed",
        });
      }
    })
    .catch((error) => {
      callback({
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Error updating customer",
      });
    });
}

export function deleteCustomer(customerId, callback) {
  axios
    .delete(`${baseURL}/customerroute/${customerId}`)
    .then((res) => {
      if (res.data.state) {
        callback({ success: true, message: res.data.message });
      } else {
        callback({
          success: false,
          message: res.data.message || "Customer deletion failed",
        });
      }
    })
    .catch((error) => {
      callback({
        success: false,
        message: error.response?.data?.message || "Error deleting customer",
      });
    });
}

export function getCustomerMetrics(callback) {
  axios
    .get(baseURL + "/customerroute/metrics", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      callback({ state: false, metrics: null, message: error.message });
    });
}

// METER OPERATIONS

export function getMeterMetrics(callback, deviceTypeId = "Meter") {
  axios
    .get(baseURL + "/meterroute/metrics", {
      params: { deviceTypeId },
    })
    .then((res) => {
      callback(res.data || { state: false, metrics: null });
    })
    .catch((error) => {
      callback({
        state: false,
        message: "Error fetching metrics",
        metrics: null,
      });
    });
}

// TARIFF OPERATIONS
export function getAllTariffs(callback) {
  axios
    .get(baseURL + "/tariffroute/tariffs", {
      params: {},
    })
    .then((res) => {
      const rawTariffs = res.data?.tariffs || [];
      const formattedTariffs = rawTariffs.map((tariff) => ({
        ...tariff,
        id: tariff.id || tariff._id,
        name: tariff.name || tariff.tariffName || "Unknown",
        rate: tariff.rate || tariff.unitRate || 0,
      }));
      callback({ state: true, tariffs: formattedTariffs });
    })
    .catch((error) => {
      callback({ state: false, tariffs: [], message: error.message });
    });
}

export function createTariff(payload, callback) {
  axios
    .post(baseURL + "/tariffroute/create", payload, {
      headers: { "Content-Type": "application/json" },
    })
    .then((res) => {
      callback({
        success: true,
        state: true,
        tariff: {
          id: res.data.tariff.id,
          data: res.data.tariff.data || res.data.tariff,
        },
        message: "Tariff created successfully",
      });
    })
    .catch((error) => {
      callback({
        success: false,
        state: false,
        tariff: null,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to create tariff",
      });
    });
}

export function updateTariff(tariffId, payload, callback) {
  axios
    .put(`${baseURL}/tariffroute/${tariffId}`, payload)
    .then((res) => {
      if (res.data?.success) {
        callback({ success: true, tariff: res.data.tariff });
      } else {
        callback({
          success: false,
          message: res.data?.message || "Tariff update failed",
        });
      }
    })
    .catch((error) => {
      callback({
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Error updating tariff",
      });
    });
}

export function deleteTariff(id, callback) {
  axios
    .delete(`${baseURL}/tariffroute/${id}`)
    .then((res) => {
      if (res.data.state) {
        callback({ success: true, message: res.data.message });
      } else {
        callback({ success: false, message: "Tariff deletion failed" });
      }
    })
    .catch((error) => {
      callback({
        success: false,
        message: error.response?.data?.message || "Error deleting tariff",
      });
    });
}

export function getTariffMetrics(callback) {
  axios
    .get(baseURL + "/tariffroute/metrics", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      callback({ state: false, metrics: null, message: error.message });
    });
}

// BILL OPERATIONS
export function getAllBills(callback) {
  axios
    .get(baseURL + "/billroute/bills", {
      params: {},
    })
    .then((res) => {
      if (res.data && res.data.bills && Array.isArray(res.data.bills)) {
        callback({
          state: true,
          bills: res.data.bills,
          message: "Bills fetched successfully",
        });
      } else {
        callback({
          state: false,
          bills: [],
          message: "Invalid response structure",
        });
      }
    })
    .catch((error) => {
      callback({ state: false, bills: [], message: error.message });
    });
}

export function createBill({ customerId, tagId, energySum, date }, callback) {
  axios
    .post(
      baseURL + "/billroute/billroute",
      { customerId, tagId, energySum, date },
      { headers: { "Content-Type": "application/json" } },
    )
    .then((res) => {
      if (!res.data) {
        callback({ success: false, error: "Invalid server response" });
        return;
      }
      callback({
        success: true,
        bill: { id: res.data.id, data: { ...res.data } },
      });
    })
    .catch((error) => {
      callback({
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "Failed to create bill",
      });
    });
}

export function getBillMetrics(callback) {
  axios
    .get(baseURL + "/billroute/metrics", {
      params: {},
    })
    .then((res) => {
      callback({ state: res.data.state, metrics: res.data.metrics });
    })
    .catch((error) => {
      callback({
        state: false,
        metrics: null,
        message: error.message || "Error fetching energy consumption metrics",
      });
    });
}

export function downloadBill(id, callback) {
  axios
    .get(baseURL + "/billroute/download/" + id, {
      responseType: "arraybuffer",
      headers: { Accept: "application/pdf" },
    })
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      callback({
        state: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to download bill",
      });
    });
}

// DEVICE AND TAG OPERATIONS
// export function getMeterDevices(orgId, projectId, callback) {
//   if (typeof callback !== "function") {
//     return;
//   }

//   if (!orgId || !projectId) {
//     callback({
//       success: false,
//       error: "Missing required parameters",
//       details: "Organization ID and Project ID are required",
//       devices: [],
//     });
//     return;
//   }

//   try {
//     const params = {
//       orgId: orgId,
//       projectId: projectId,
//     };

//     axios
//       .get(`${baseURL}/meterroute/getMeterDevices`, {
//         params: params,
//         headers: {
//           "Content-Type": "application/json",
//         },
//       })
//       .then((response) => {
//         callback({
//           success: true,
//           orgId: orgId,
//           projectId: projectId,
//           devices: response.data.devices || [],
//           count: response.data.devices?.length || 0,
//         });
//       })
//       .catch((error) => {
//         callback({
//           success: false,
//           error: error.message || "Failed to fetch meter devices",
//           orgId: orgId,
//           projectId: projectId,
//           devices: [],
//           timestamp: new Date().toISOString(),
//         });
//       });
//   } catch (error) {
//     callback({
//       success: false,
//       error: error.message || "Unexpected error occurred",
//       orgId: orgId,
//       projectId: projectId,
//       devices: [],
//       timestamp: new Date().toISOString(),
//     });
//   }
// }
export function getMeterDevices(callback) {
  axios
    .get(baseURL + "/meterroute/getMeterDevices", {
      params: {},
    })
    .then((res) => {
      const rawDevices = res.data?.devices || [];
      const formattedDevices = rawDevices.map((device) => ({
        ...device,
        id: device.DeviceID,
        name: `${device.Name || "Meter"} (${device.SN || "N/A"})`,
        rate: "",
      }));
      callback({ state: true, devices: formattedDevices });
    })
    .catch((error) => {
      callback({ state: false, devices: [], message: error.message });
    });
}

export function getTagsForDevices(deviceIds, callback) {
  if (!Array.isArray(deviceIds) || deviceIds.length === 0) {
    const errorResult = {
      state: false,
      error: "deviceIds array is required",
      tags: [],
    };
    if (typeof callback === "function") callback(errorResult);
    return Promise.resolve(errorResult);
  }

  const deviceIdArray = deviceIds.map((d) =>
    typeof d === "string" ? d : d.DeviceID,
  );
  const params = {
    deviceId: deviceIdArray.join(","),
  };

  const request = axios
    .get(`${baseURL}/meterroute/getTagsForDevice`, {
      params,
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      const rawTags = response.data.tags || [];
      const formattedTags = rawTags.map((tag) => ({
        ...tag,
        id: tag.tagId || tag.id,
        name: tag.name || tag.Name || tag.tagId,
        unit: tag.unit || tag.Unit || "",
        deviceId: tag.deviceId || tag.DeviceID,
      }));
      const result = {
        state: true,
        deviceIds,
        tags: formattedTags,
        count: formattedTags.length,
      };
      if (typeof callback === "function") callback(result);
      return result;
    })
    .catch((error) => {
      const result = {
        state: false,
        error: error.message,
        deviceIds,
        tags: [],
      };
      if (typeof callback === "function") callback(result);
      return result;
    });

  return request;
}

export function getOneDayEnergySum(tagId, date, callback) {
  if (!tagId || (Array.isArray(tagId) && tagId.length === 0)) {
    callback({
      success: false,
      error: "tagId is required",
      energySum: 0,
    });
    return;
  }

  const tagIdString = Array.isArray(tagId) ? tagId[0] : tagId;
  const params = { tagId: tagIdString };

  if (date) {
    params.date = date;
  }

  const apiUrl = `${baseURL}/billroute/getOneDayEnergy`;

  axios
    .get(apiUrl, {
      params,
      headers: { "Content-Type": "application/json" },
    })
    .then((response) => {
      const data = response?.data;

      if (data && typeof data === "object") {
        callback({
          success: data.success ?? true,
          tagId: data.tagId,
          date: data.date,
          energySum: data.energySum || 0,
          message: data.message,
        });
      } else {
        callback({
          success: false,
          error: "Unexpected response format",
          energySum: 0,
        });
      }
    })
    .catch((error) => {
      callback({
        success: false,
        error: error.response?.data?.error || error.message,
        energySum: 0,
        timestamp: new Date().toISOString(),
      });
    });
}

export function updatedashboardgroup(
  orgid,
  projid,
  groupid,
  groupname,
  callback,
) {
  axios
    .put(baseURL + "/configuration/updatedashboardgroup", null, {
      params: {
        organizationid: orgid,
        projectid: projid,
        newgroupname: groupname,
        groupid: groupid,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function deleteDashboardgroup(orgid, projid, groupid, callback) {
  axios
    .delete(baseURL + "/configuration/deletedashboardgroup", {
      params: {
        organizationid: orgid,
        projectid: projid,
        groupid: groupid,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function updadashboardname(dashboardid, newname, callback) {
  axios
    .put(baseURL + "/configuration/updatedashboard", null, {
      params: {
        dashboardid: dashboardid,
        newname: newname,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

// Unified dashboard update (name and/or group move). Optional params newname, newgroupid.
// Keeps existing updadashboardname function for backward compatibility; prefer using updateDashboard.
export function updateDashboard(
  dashboardid,
  { newname, newgroupid } = {},
  callback,
) {
  if (!newname) {
    callback && callback({ status: "fail", message: "newname is required" });
    return;
  }
  const params = { dashboardid, newname };
  if (newgroupid) params.newgroupid = newgroupid;
  axios
    .put(baseURL + "/configuration/updatedashboard", null, { params })
    .then((res) => {
      callback && callback(res.data);
    })
    .catch((err) => {
      callback && callback({ status: "fail", message: err.message });
    });
}

// ================= Dashboard Bulk Data Points (New Helpers) =================
// Build tag operations list from a widget definition (extended.datapoints preferred)
export function buildTagOpsFromWidget(widget) {
  const ext = widget?.props?.extended || {};
  const list =
    Array.isArray(ext.datapoints) && ext.datapoints.length
      ? ext.datapoints
      : Array.isArray(ext.tagprops)
        ? ext.tagprops
        : [];
  return list
    .filter((p) => p && (p.tagid || p.key || p.id))
    .map((p) => ({
      tagid: (p.tagid || p.key || p.id).toString(),
      operation: (p.storageSelection || p.operation || "AVG").toUpperCase(),
      name:
        p.datapointName ||
        p.name ||
        p.title ||
        p.tagname ||
        p.alias ||
        p.tagid ||
        p.key,
    }));
}

// Low-level fetch for GET /dashboard/dashboardDataPoints (returns Promise)
export function fetchDashboardDataPoints(
  tagOpsArray,
  sdate,
  edate,
  datetype = "",
) {
  return new Promise((resolve, reject) => {
    if (!Array.isArray(tagOpsArray) || !tagOpsArray.length) {
      return reject(new Error("No tag operations supplied"));
    }
    const toISO = (d) => {
      if (!d) return "";
      if (d instanceof Date) return d.toISOString();
      const dt = new Date(d);
      return isNaN(dt.getTime()) ? "" : dt.toISOString();
    };
    let startISO = toISO(sdate);
    let endISO = toISO(edate);
    // Override for full previous calendar month if datetype === 'Last Month'
    if (datetype === "Last Month") {
      const now = new Date();
      const prevMonthIndex = now.getMonth() === 0 ? 11 : now.getMonth() - 1;
      const yearForPrev =
        now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();
      const startPrevUTC = new Date(
        Date.UTC(yearForPrev, prevMonthIndex, 1, 0, 0, 0, 0),
      );
      const endPrevUTC = new Date(
        Date.UTC(yearForPrev, prevMonthIndex + 1, 0, 23, 59, 59, 999),
      );
      startISO = startPrevUTC.toISOString();
      endISO = endPrevUTC.toISOString();
      // eslint-disable-next-line no-console
      console.log(
        "[fetchDashboardDataPoints] Overriding Last Month range to full previous month",
        { startISO, endISO },
      );
    }
    if (!startISO || !endISO) return reject(new Error("Invalid date range"));
    const clean = tagOpsArray
      .filter((o) => o && o.tagid)
      .map((o) => ({
        tagid: String(o.tagid).trim(),
        operation: (o.operation || "AVG").toUpperCase(),
      }));
    if (!clean.length) return reject(new Error("No valid tag IDs"));
    // Pass raw JSON; let axios encode once. Avoid pre-encoding to prevent %25 double-encoding.
    const tagidsParam = JSON.stringify(clean);
    axios
      .get(baseURL + "/dashboard/dashboardDataPoints", {
        params: {
          sdate: startISO,
          edate: endISO,
          datetype,
          tagids: tagidsParam,
        },
      })
      .then((res) => {
        const raw = res.data || {};
        const dataObj = raw.data || {};
        const byTag = {};
        const series = [];
        Object.entries(dataObj).forEach(([tid, arr]) => {
          const pts = Array.isArray(arr)
            ? arr
                .map((p) => ({
                  x: Number(p.x) * 1000,
                  y: typeof p.y === "number" ? p.y : Number(p.y),
                }))
                .filter((p) => !isNaN(p.x) && !isNaN(p.y))
            : [];
          byTag[tid] = pts;
          const op =
            (clean.find((c) => c.tagid === tid) || {}).operation || "AVG";
          series.push({ tagid: tid, operation: op, points: pts });
        });
        resolve({ byTag, series, raw });
      })
      .catch((err) => reject(err));
  });
}

// Aggregate all widgets, fetch once, distribute results per widget
export function fetchDataForWidgets(widgets, sdate, edate, datetype = "") {
  // Group widgets by their effective date range (historic widgets may have their own)
  const toISO = (val) => {
    if (!val) return "";
    if (val instanceof Date) return val.toISOString();
    const d = new Date(val);
    return isNaN(d.getTime()) ? "" : d.toISOString();
  };
  const groups = {};
  widgets.forEach((w) => {
    const ext = w.props?.extended || {};
    const widgetMode = (ext.dataType || ext.datatype || "live").toLowerCase();
    const isHistoric = widgetMode === "historic" || widgetMode === "mixed";
    const range = isHistoric && ext.dateRange ? ext.dateRange : null;
    const rawStart = isHistoric && range?.start ? range.start : sdate;
    const rawEnd = isHistoric && range?.end ? range.end : edate;
    const startISO = toISO(rawStart);
    const endISO = toISO(rawEnd);
    const label = isHistoric && range?.label ? range.label : datetype || "";
    const groupKey = `${startISO}__${endISO}__${label}`;
    if (!groups[groupKey])
      groups[groupKey] = { start: startISO, end: endISO, label, widgets: [] };
    groups[groupKey].widgets.push(w);
  });
  // groups now guaranteed normalized; identical ranges collapse
  const groupKeys = Object.keys(groups);
  if (!groupKeys.length) return Promise.resolve({ widgetData: {} });
  const finalWidgetData = {};
  // Sequentially (could be optimized parallel) fetch each group to avoid overwhelming backend
  let chain = Promise.resolve();
  groupKeys.forEach((gk) => {
    chain = chain.then(() => {
      const { start, end, label, widgets: gwidgets } = groups[gk];
      // eslint-disable-next-line no-console
       // Build combined operations for this date window
      const all = [];
      const tagToWidgets = {};
      gwidgets.forEach((w) => {
        buildTagOpsFromWidget(w).forEach((op) => {
          const key = `${op.tagid}__${op.operation}`;
          all.push({ tagid: op.tagid, operation: op.operation });
          if (!tagToWidgets[key]) tagToWidgets[key] = [];
          tagToWidgets[key].push({
            widgetId: w.id,
            name: op.name,
            tagid: op.tagid,
            operation: op.operation,
          });
        });
      });
      const dedupe = {};
      all.forEach((o) => {
        dedupe[`${o.tagid}__${o.operation}`] = o;
      });
      const unique = Object.values(dedupe);
      if (!unique.length) return Promise.resolve();
      return fetchDashboardDataPoints(unique, start, end, label).then(
        ({ byTag }) => {
          Object.keys(tagToWidgets).forEach((key) => {
            const [tid] = key.split("__");
            const pts = byTag[tid] || [];
            tagToWidgets[key].forEach((ref) => {
              if (!finalWidgetData[ref.widgetId])
                finalWidgetData[ref.widgetId] = [];
              finalWidgetData[ref.widgetId].push({
                tagid: ref.tagid,
                operation: ref.operation,
                name: `${ref.name} (${ref.operation})`,
                points: pts,
                fetchSource: "historic",
              });
            });
          });
        },
      );
    });
  });
  return chain.then(() => ({ widgetData: finalWidgetData }));
}

// CAPTCHA API methods
// Fetch a new CAPTCHA challenge
export function fetchCaptchaChallenge(callback) {
  axios
    .get(baseURL + "/api/captcha", {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      callback({ data: res.data, status: "success" });
    })
    .catch((err) => {
      callback({
        error: err.response
          ? err.response.data
          : { error: err.response.message },
        status: err.response ? err.response.status : 500,
      });
    });
}

// Verify the user's CAPTCHA answer
export function verifyCaptchaAnswer(answer, token, callback) {
  axios
    .post(
      baseURL + "/api/captcha/verify",
      { token: token, answer: answer },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    )
    .then((res) => {
      callback({ data: res.data, status: "success" });
    })
    .catch((err) => {
      callback({
        error: err.response
          ? err.response.data
          : { error: err.response.message },
        status: err.response ? err.response.status : 500,
      });
    });
}

export function getTagConfiguration(callback) {
  axios
    .get(baseURL + "/report/tagConfiguration", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getDynamicTagStandard(callback) {
  axios
    .get(baseURL + "/report/dynamicTagStandard", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    });
}

export function addStandardTemplates(callback) {
  axios
    .get(baseURL + "/report/addStandardTemplates", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getDynamicTag(callback) {
  axios
    .get(baseURL + "/report/dynamicTag", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getDevicesReportGen(templateId, callback) {
  axios
    .get(baseURL + "/report/getDevices", {
      params: {
        templateId: templateId,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function cloneTemplate(templateID, templateName, groupID, callback) {
  axios
    .post(baseURL + "/report/cloneTemplate", null, {
      params: {
        templateID: templateID,
        templateName: templateName,
        groupID: groupID,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getDashboardGroupsReports(callback) {
  axios
    .get(baseURL + "/report/getDashboardGroups", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getDashboardsReports(groupID, callback) {
  axios
    .get(baseURL + "/report/getDashboards", {
      params: {
        groupID: groupID,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function addLog(messageCategory, message, callback) {
  axios
    .post(baseURL + "/elogbook/addLog", null, {
      params: {
        messageCategory: messageCategory,
        message: message,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getLogs(callback) {
  axios
    .get(baseURL + "/elogbook/getLogs", {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    });
}

export function deleteLog(logId, callback) {
  axios
    .post(baseURL + "/elogbook/deleteLog", null, {
      params: {
        logId: logId,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function editLog(logId, messageCategory, message, callback) {
  axios
    .post(baseURL + "/elogbook/editLog", null, {
      params: {
        logId: logId,
        messageCategory: messageCategory,
        message: message,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function addReportScheduler(
  schedulerName,
  templateID,
  deviceIds,
  frequency,
  startDT,
  endDT,
  genDT,
  email,
  exportType,
  userGroups,
  enableScheduler,
  callback,
) {
  axios
    .post(baseURL + "/report/addScheduler", null, {
      params: {
        schedulerName: schedulerName,
        templateID: templateID,
        deviceIds: deviceIds,
        frequency: frequency,
        startDT: startDT,
        endDT: endDT,
        genDT: genDT,
        email: email,
        exportType: exportType,
        userGroups: userGroups,
        enableScheduler: enableScheduler,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function deleteReportScheduler(data, callback) {
  axios
    .post(baseURL + "/report/deleteScheduler", null, {
      params: { data: data },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function disableReportScheduler(data, callback) {
  axios
    .post(baseURL + "/report/disableScheduler", null, {
      params: { data: data },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function enableReportScheduler(data, callback) {
  axios
    .post(baseURL + "/report/enableScheduler", null, {
      params: { data: data },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getSavedReportScheduler(callback) {
  axios
    .post(baseURL + "/report/savedScheduler", null, {
      params: {},
    })
    .then((res) => {
      callback(res.data);
    });
}

export function getReportSchedulerByID(schedulerID, callback) {
  axios
    .post(baseURL + "/report/savedSchedulerByID", null, {
      params: {
        schedulerID: schedulerID,
      },
    })
    .then((res) => {
      callback(res.data);
    });
}

export function raiseChatbotTicket(notificationPayload = {}) {
  const configuredEndpoint =
    process.env.REACT_APP_BOT_TICKET_ENDPOINT || "/chatbot/raiseTicket";

  const resolvedEndpoint = /^https?:\/\//i.test(configuredEndpoint)
    ? configuredEndpoint
    : `${baseURL}${configuredEndpoint.startsWith("/") ? "" : "/"}${configuredEndpoint}`;

  return axios.post(resolvedEndpoint, notificationPayload, {
    headers: { "Content-Type": "application/json" },
  });
}

//TICKETING
const getTicketApiErrorSummary = (error) => ({
  status: error?.response?.status || null,
  message:
    error?.response?.data?.error ||
    error?.response?.data?.message ||
    error?.message ||
    "Unknown ticket API error",
  jiraSync: error?.response?.data?.jiraSync || null,
});

const getTicketPayloadSummary = (payload = {}) => ({
  subject: payload?.subject || null,
  ticket_id: payload?.ticket_id || payload?.operate_ticket_id || payload?.ticketId || null,
  jira_issue_key: payload?.jira_issue_key || null,
  project_id: payload?.project_id || null,
  organization_id: payload?.organization_id || null,
  request_type: payload?.request_type || null,
});

async function callTicketApiWithFallback(operationName = "ticket-api", requests = []) {
  let lastError = null;

  for (let index = 0; index < requests.length; index += 1) {
    const request = requests[index];
    const requestFactory = request?.requestFactory;
    const routeLabel = request?.routeLabel || `attempt-${index + 1}`;

    if (typeof requestFactory !== "function") {
      console.warn(`[TicketAPI] ${operationName} skipped invalid request factory`, {
        attempt: index + 1,
        routeLabel,
      });
      continue;
    }

    try {
      console.log(`[TicketAPI] ${operationName} -> attempt ${index + 1} starting`, {
        routeLabel,
      });
      const response = await requestFactory();
      console.log(`[TicketAPI] ${operationName} -> attempt ${index + 1} success`, {
        routeLabel,
        status: response?.status || null,
        success: response?.data?.success,
        message: response?.data?.message || response?.data?.error || null,
        jiraSync: response?.data?.jiraSync || null,
      });
      return response;
    } catch (error) {
      lastError = error;
      const errorSummary = getTicketApiErrorSummary(error);

      console.error(`[TicketAPI] ${operationName} -> attempt ${index + 1} failed`, {
        routeLabel,
        ...errorSummary,
      });

      if (error?.response?.status !== 404) {
        throw error;
      }

      console.warn(`[TicketAPI] ${operationName} -> falling back after 404`, {
        routeLabel,
      });
    }
  }

  console.error(`[TicketAPI] ${operationName} -> all attempts failed`, {
    error: getTicketApiErrorSummary(lastError || {}),
  });

  throw lastError || new Error("Ticket API request failed");
}

export function createJiraIssueSync(payload = {}) {
  console.log("[TicketAPI] createJiraIssueSync called", getTicketPayloadSummary(payload));
  return callTicketApiWithFallback("createJiraIssueSync", [
    {
      routeLabel: "/api/tickets/create",
      requestFactory: () => axios.post(baseURL + "/api/tickets/create", payload),
    },
    {
      routeLabel: "/ticket/api/tickets/create",
      requestFactory: () => axios.post(baseURL + "/ticket/api/tickets/create", payload),
    },
  ]);
}

export function transitionTicketStatus(payload = {}) {
  console.log("[TicketAPI] transitionTicketStatus called", getTicketPayloadSummary(payload));
  return callTicketApiWithFallback("transitionTicketStatus", [
    {
      routeLabel: "/api/tickets/transition",
      requestFactory: () => axios.put(baseURL + "/api/tickets/transition", payload),
    },
    {
      routeLabel: "/ticket/api/tickets/transition",
      requestFactory: () => axios.put(baseURL + "/ticket/api/tickets/transition", payload),
    },
  ]);
}

export function addTicketComment(payload = {}) {
  console.log("[TicketAPI] addTicketComment called", getTicketPayloadSummary(payload));
  return callTicketApiWithFallback("addTicketComment", [
    {
      routeLabel: "/api/tickets/comment",
      requestFactory: () => axios.post(baseURL + "/api/tickets/comment", payload),
    },
    {
      routeLabel: "/ticket/api/tickets/comment",
      requestFactory: () => axios.post(baseURL + "/ticket/api/tickets/comment", payload),
    },
  ]);
}

export function reopenTicket(payload = {}) {
  console.log("[TicketAPI] reopenTicket called", getTicketPayloadSummary(payload));
  return callTicketApiWithFallback("reopenTicket", [
    {
      routeLabel: "/api/tickets/reopen",
      requestFactory: () => axios.post(baseURL + "/api/tickets/reopen", payload),
    },
    {
      routeLabel: "/ticket/api/tickets/reopen",
      requestFactory: () => axios.post(baseURL + "/ticket/api/tickets/reopen", payload),
    },
  ]);
}

export function updateTicketSync(payload = {}) {
  console.log("[TicketAPI] updateTicketSync called", getTicketPayloadSummary(payload));
  return callTicketApiWithFallback("updateTicketSync", [
    {
      routeLabel: "/api/tickets/update",
      requestFactory: () => axios.put(baseURL + "/api/tickets/update", payload),
    },
    {
      routeLabel: "/ticket/api/tickets/update",
      requestFactory: () => axios.put(baseURL + "/ticket/api/tickets/update", payload),
    },
  ]);
}

export function getTickets(params = {}) {
  console.log("[TicketAPI] getTickets called", {
    project_id: params?.project_id || null,
    organization_id: params?.organization_id || null,
  });

  return axios
    .get(baseURL + "/ticket/getTickets", {
      params,
    })
    .then((response) => {
      const ticketCount =
        response?.data?.tickets?.length ||
        response?.data?.data?.length ||
        0;

      console.log("[TicketAPI] getTickets success", {
        status: response?.status || null,
        ticketCount,
      });

      return response;
    })
    .catch((error) => {
      console.error("[TicketAPI] getTickets failed", getTicketApiErrorSummary(error));
      throw error;
    });
}

export function createTicketWithAttachments(ticketPayload, attachments = []) {
  console.log("[TicketAPI] createTicketWithAttachments called", {
    payload: getTicketPayloadSummary(ticketPayload),
    attachmentCount: Array.isArray(attachments) ? attachments.length : 0,
    attachmentNames: Array.isArray(attachments)
      ? attachments.filter(Boolean).map((file) => file?.name || "unnamed")
      : [],
  });

  const formData = new FormData();
  formData.append("ticket", JSON.stringify(ticketPayload || {}));

  if (Array.isArray(attachments)) {
    attachments.forEach((file) => {
      if (file) {
        formData.append("attachments", file);
      }
    });
  }

  return axios
    .post(baseURL + "/ticket/createTicket", formData)
    .then((response) => {
      console.log("[TicketAPI] createTicketWithAttachments success", {
        status: response?.status || null,
        success: response?.data?.success,
        message: response?.data?.message || response?.data?.error || null,
        ticket_id:
          response?.data?.data?.ticket_id ||
          response?.data?.ticket_id ||
          null,
        jiraSync: response?.data?.jiraSync || null,
      });
      return response;
    })
    .catch((error) => {
      console.error(
        "[TicketAPI] createTicketWithAttachments failed",
        getTicketApiErrorSummary(error)
      );
      throw error;
    });
}

export function getTicketSyncStatus(ticketId) {
  console.log("[TicketAPI] getTicketSyncStatus called", {
    ticket_id: ticketId || null,
  });

  return axios
    .get(baseURL + `/ticket/status/${ticketId}`)
    .then((response) => {
      console.log("[TicketAPI] getTicketSyncStatus success", {
        status: response?.status || null,
        ticket_id: response?.data?.ticket_id || ticketId || null,
        jira_sync_status: response?.data?.jira_sync_status || null,
      });
      return response;
    })
    .catch((error) => {
      console.error("[TicketAPI] getTicketSyncStatus failed", getTicketApiErrorSummary(error));
      throw error;
    });
}

export function retryTicketSync(ticketId) {
  console.log("[TicketAPI] retryTicketSync called", {
    ticket_id: ticketId || null,
  });

  return axios
    .post(baseURL + `/ticket/retrySync/${ticketId}`)
    .then((response) => {
      console.log("[TicketAPI] retryTicketSync success", {
        status: response?.status || null,
        ticket_id: response?.data?.ticket_id || ticketId || null,
      });
      return response;
    })
    .catch((error) => {
      console.error("[TicketAPI] retryTicketSync failed", getTicketApiErrorSummary(error));
      throw error;
    });
}

export function sendTicketRaisedEmail(notificationPayload = {}) {
  const endpoint =
    process.env.REACT_APP_TICKET_EMAIL_ENDPOINT || "/ticket/emailNotification";

  console.log("[TicketAPI] sendTicketRaisedEmail called", {
    endpoint,
    ticket_id: notificationPayload?.ticket_id || notificationPayload?.ticketId || null,
    customer_email:
      notificationPayload?.customer_email || notificationPayload?.customerEmail || null,
  });

  return axios
    .post(baseURL + endpoint, notificationPayload, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      console.log("[TicketAPI] sendTicketRaisedEmail success", {
        status: response?.status || null,
        sent:
          response?.data?.sent ||
          response?.data?.isSent ||
          response?.data?.emailNotification?.sent ||
          null,
      });
      return response;
    })
    .catch((error) => {
      console.error("[TicketAPI] sendTicketRaisedEmail failed", getTicketApiErrorSummary(error));
      throw error;
    });
}


export { apiService };
export { userAccessService };

// ============================================================================
// DIGITAL TWIN MODULE APIs — Phases 3-6
// ============================================================================

export const digitalTwinApi = {
  // Phase 3: Model files (upload via API relay → blob; download = read SAS URL)
  getModels: () => axios.get(`${baseURL}/digital-twin/models`),
  getModel: (id) => axios.get(`${baseURL}/digital-twin/models/${id}`),
  /** Multipart field name must be `model`. Same-origin upload (no blob CORS for PUT). */
  uploadModel: (formData) =>
    axios.post(`${baseURL}/digital-twin/models/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  requestUploadSas: (body) =>
    axios.post(`${baseURL}/digital-twin/models/upload-sas`, body),
  confirmUpload: (body) =>
    axios.post(`${baseURL}/digital-twin/models/confirm`, body),
  deleteModel: (id) => axios.delete(`${baseURL}/digital-twin/models/${id}`),
  /** Returns a time-limited read SAS URL for useGLTF / fetch (not the API base URL). */
  getModelDownloadUrl: async (id) => {
    const res = await axios.get(`${baseURL}/digital-twin/models/${id}/download-url`);
    return res.data.url;
  },

  // Phase 4: Component bindings (nested per-file document)
  getFileBindings: (fileId) =>
    axios.get(`${baseURL}/digital-twin/bindings/${fileId}`),
  setComponentBinding: (fileId, fileName, componentId, data) =>
    axios.put(`${baseURL}/digital-twin/bindings/${fileId}/components/${componentId}`, {
      file_name: fileName,
      ...data,
    }),
  removeComponentBinding: (fileId, componentId) =>
    axios.delete(`${baseURL}/digital-twin/bindings/${fileId}/components/${componentId}`),
  updateComponentDashboard: (fileId, componentId, dashboardId) =>
    axios.put(
      `${baseURL}/digital-twin/bindings/${fileId}/components/${componentId}/dashboard`,
      { dashboard_id: dashboardId }
    ),
  batchAssignDashboard: (fileId, componentIds, dashboardId) =>
    axios.put(
      `${baseURL}/digital-twin/bindings/${fileId}/dashboard/batch`,
      { component_ids: componentIds, dashboard_id: dashboardId }
    ),

  // Phase 5: DT Dashboards
  getDashboard: (bindingId) => axios.get(`${baseURL}/digital-twin/dashboards/${bindingId}`),
  createDashboard: (dashboard) => axios.post(`${baseURL}/digital-twin/dashboards`, dashboard),
  updateDashboard: (id, data) => axios.put(`${baseURL}/digital-twin/dashboards/${id}`, data),
  deleteDashboard: (id) => axios.delete(`${baseURL}/digital-twin/dashboards/${id}`),

  // Phase 6: Tag-device structure & widget tag bindings
  // Returns { data: { success, devices: [{ DeviceName, DeviceID, tagdetails: [{ TagID, TagName, PayloadName, Alias, Unit, ... }] }] } }
  // The index header scopes the response to the currently selected project.
  getTagDeviceStructure: () =>
    axios.get(`${baseURL}/digital-twin/tag-device-structure`, {
      headers: { index: localStorage.getItem('selectedProjectIndex') || '0' },
    }),
  getGateways: () =>
    axios.get(`${baseURL}/digital-twin/gateways`, {
      headers: { index: localStorage.getItem('selectedProjectIndex') || '0' },
    }),
  getWidgetBindings: (dashboardId) =>
    axios.get(`${baseURL}/digital-twin/widget-bindings`, { params: { dashboard_id: dashboardId } }),
  createWidgetBinding: (binding) =>
    axios.post(`${baseURL}/digital-twin/widget-bindings`, binding),
  updateWidgetBinding: (id, data) =>
    axios.put(`${baseURL}/digital-twin/widget-bindings/${id}`, data),
  deleteWidgetBinding: (id) =>
    axios.delete(`${baseURL}/digital-twin/widget-bindings/${id}`),
};
